import { apSelfAssessmentTranslations } from './ap-self-assessment.js';
export const ledgerTranslations = {
    de: {
        selfAssessment: apSelfAssessmentTranslations.de,
        unsavedTitle: 'Ungespeicherte Änderungen',
        unsavedHint: 'Deine Eingaben sind noch nicht gespeichert. Möchtest du sie verwerfen?',
        discard: 'Änderungen verwerfen',
        vendorAllocation: {
            matchRequired: 'Zuerst den Rechnungsabgleich ausführen. Danach diese Vorschau erneut öffnen.',
            title: 'Kontierung und Buchung',
            hint: 'Original prüfen, Beträge auf Kosten- oder Anlagenkonten verteilen und die Buchung vor der Freigabe kontrollieren. Die Originalbeträge bleiben erhalten.',
            rate: 'Umrechnungskurs',
            zero: 'Der Originalbeleg hat keinen Betrag. Es werden weder eine Zahlung noch eine Buchung erzeugt.',
            saved: 'Kontierung gespeichert. Die neue Buchungsvorschau kann jetzt geprüft werden.',
            amountHint: 'Nettobeträge in {{currency}} aufteilen. Punkt oder Komma als Dezimalzeichen verwenden, ohne Tausendertrennzeichen. Nicht abziehbare Vorsteuer erhöht den Aufwand bzw. die Anschaffungskosten.',
            row: 'Aufteilung {{number}}',
            account: 'Sachkonto {{number}}',
            netAmount: 'Nettobetrag {{number}}',
            taxRate: 'Steuersatz % {{number}}',
            inputTaxDeductionPercent: 'Vorsteuerabzug % {{number}}',
            costCenterId: 'Kostenstelle {{number}}',
            costObjectId: 'Kostenträger {{number}}',
            description: 'Buchungstext {{number}}',
            remove: 'Aufteilung {{number}} entfernen',
            rowResult: 'Abziehbare Vorsteuer: {{deductible}} · Aufwand/Anschaffungskosten: {{cost}}',
            add: 'Aufteilung hinzufügen',
            save: 'Kontierung speichern',
            edit: 'Kontierung bearbeiten',
            dimensions: 'Kostenstelle / Kostenträger',
            reason: 'Begründung bei Abweichungen',
            checked: 'Original und Kontierung geprüft',
            approve: 'Geprüft freigeben und buchen',
            refresh: 'Vorschau aktualisieren',
            findings: {
                invalidInput: 'Bitte alle markierten Angaben prüfen. Beträge ohne Tausendertrennzeichen eingeben.',
                duplicatePosition: 'Jede Aufteilung benötigt eine eindeutige Position.',
                allocationTotalMismatch: 'Die Aufteilung muss je Steuersatz genau dem Nettobetrag des Originals entsprechen.',
                allocationTaxRateMismatch: 'Der Steuersatz der Aufteilung ist im Original nicht vorhanden.',
                allocationSignMismatch: 'Eine Aufteilung darf das Vorzeichen des Originalbetrags nicht umkehren.',
                zeroTaxBase: 'Steuer ohne passende Nettobasis erfordert eine gesonderte Prüfung.',
                sourceTaxMismatch: 'Die Steuerbeträge lassen sich dem Original nicht eindeutig zuordnen.',
                amountOverflow: 'Der berechnete Betrag überschreitet den zulässigen Wertebereich.',
                invoiceNotEditable: 'Diese Rechnung ist bereits freigegeben oder aufgehoben. Die festgehaltene Kontierung bleibt unverändert.',
                allocationMissing: 'Die ausgewählte Kontierung fehlt. Bitte die Aufteilung erneut prüfen.',
                costAccountInvalid: 'Ein aktives Aufwands-, Bestands- oder Anlagenkonto in der Buchungswährung auswählen. Geld-, Steuer- und Sammelkonten sind hier nicht zulässig.',
                dimensionInvalid: 'Eine aktive Kostenstelle bzw. einen aktiven Kostenträger dieses Unternehmens auswählen.',
                reviewRequired: 'Vor der Freigabe die aktuelle Buchungsvorschau prüfen und bestätigen.',
                serviceDateAssumed: 'Ein gesondertes Leistungsdatum fehlt. Für die Prüfung wird das Rechnungsdatum angesetzt; bitte am Original kontrollieren.',
            },
        },
        vendorCorrection: {
            recorded: 'Festgehaltene Korrektur',
            author: 'Bearbeitung',
            title: 'Fehlerhafte Eingangsrechnungserfassung',
            open: 'Erfassung prüfen',
            post: 'Erfassung aufheben',
            evidence: 'Nachweis der Korrektur',
            review: 'Nachweise neu prüfen',
            hint: 'Korrigiere eine irrtümliche Erfassung mit Datum, Begründung und Nachweis. Tatsächliche Zahlungen und Lieferantengutschriften werden gesondert erfasst. Originalbeleg und Ursprungsbuchung bleiben erhalten.',
            taxHint: 'Steuerwirksame Erfassungskorrekturen betreffen den ursprünglichen Steuerzeitraum. Ein späteres Buchungsdatum hebt dessen Sperre nicht auf.',
            sourceChanged: 'Die Nachweise haben sich geändert. Prüfe sie erneut, bevor du die Korrektur festschreibst.',
            permission: 'Für eine gebuchte Eingangsrechnung ist zusätzlich das Recht zur Buchungskorrektur erforderlich.',
            unbooked: 'Diese Erfassung wurde noch nicht in das Hauptbuch übernommen. Ihr Aufheben erzeugt keine Buchung.',
            taxDate: 'Steuerdatum der Ursprungsbuchung',
            correctionJournal: 'Gegenbuchung',
            saved: 'Erfassung nachvollziehbar aufgehoben.',
        },
        writeOff: {
            recover: 'Späteren Zahlungseingang zuordnen',
            recoveryHint: 'Wähle einen vorhandenen tatsächlichen Eingang desselben Kunden. Die Forderung wird für diesen Betrag wiederhergestellt und sofort mit der Zahlung ausgeglichen. Es entsteht keine weitere Geldbewegung. Für die Steuer zählt der tatsächliche Zahlungstag.',
            recoverable: 'Verbleibender ausgebuchter Betrag',
            noReceipts: 'Keine passenden Eingänge mit Restbetrag ab dem Ausbuchungsdatum. Erfasse den tatsächlichen Eingang zuerst unter Zahlungen.',
            recoveryReason: 'Späteren tatsächlichen Zahlungseingang einer ausgebuchten Forderung zugeordnet',
            recoveryAmount: 'Zuzuordnender Betrag',
            recoverySave: 'Zahlung zuordnen und Forderung wiederherstellen',
            recoveryReview: 'Zahlung und Ausbuchung neu prüfen',
            recoveryReviewed: 'Restbeträge und Nachweise aktualisiert. Prüfe Betrag und Datum vor dem Speichern.',
            receiptLink: 'Vorhandene Zahlung öffnen',
            title: 'Forderungsausfälle',
            review: 'Forderungsausfall prüfen',
            hint: 'Erfasst einen begründeten Forderungsausfall ohne Zahlungseingang. Prüfe den Nachweis der Uneinbringlichkeit und die steuerliche Behandlung vor der Übernahme.',
            amount: 'Auszubuchender Bruttobetrag',
            evidence: 'Nachweis der Uneinbringlichkeit',
            account: 'Aufwandskonto für Forderungsausfälle',
            selectAccount: 'Konto auswählen',
            noAccount: 'Lege unter Sachkonten ein Aufwandskonto mit Verwendung Forderungsausfall an.',
            confirm: 'Uneinbringlichkeit und steuerliche Behandlung geprüft',
            preview: 'Vorschau berechnen',
            post: 'Ausbuchung festschreiben',
            tax: 'Steuerkorrektur',
            expense: 'Aufwand',
            reverse: 'Fehlerhafte Ausbuchung aufheben',
            reverseHint: 'Korrigiert eine falsch erfasste Ausbuchung. Der ursprüngliche Steuerzeitraum muss offen sein. Eine später tatsächlich vereinnahmte Forderung benötigt einen eigenen Ausgleich mit Steuerberichtigung.',
            recorded: 'Ausgebucht',
            reversed: 'Ausbuchung aufgehoben',
            empty: 'Für diese Forderung gibt es noch keine Ausbuchung.',
        },
        documentDefaultsHint: 'Ohne abweichende Angaben bestimmt das ERP Buchungs- und Steuerdatum aus Belegart, Beleg- und Leistungsdatum. Der Wechselkurs gibt den Wert einer Einheit Belegwährung in Buchhaltungswährung an. Die Kursquelle bleibt intern.',
        views: {
            overview: 'Finanzen / Buchhaltung',
            journal: 'Buchungsjournal',
            accounts: 'Sachkonten',
            reports: 'Auswertungen',
            periods: 'Geschäftsjahre und Perioden',
        },
        subtitle: 'Buchungen mit Belegbezug erfassen, prüfen und nachvollziehen.',
        navigation: 'Buchhaltungsbereiche',
        help: 'Hilfe zur Buchhaltung',
        forbidden: 'Für die Buchhaltung fehlt die Leseberechtigung.',
        setup: 'Buchhaltung einrichten',
        setupHint: 'Wähle den Buchhaltungsstart. Bei vorhandenen Rechnungen oder Zahlungen ist zuerst eine geprüfte Bestandsübernahme erforderlich. Der kleine Startkontenplan ist frei erweiterbar und kein vollständiger DATEV-Kontenrahmen.',
        startDate: 'Buchhaltungsstart',
        vatMethod: 'Umsatzsteuerverfahren',
        ACCRUAL: 'Sollversteuerung',
        CASH: 'Istversteuerung (genehmigungspflichtig)',
        saved: 'Gespeichert.',
        newJournal: 'Buchung erfassen',
        journalHint: 'Alle Beträge in der Buchhaltungswährung. Jede Zeile enthält Soll oder Haben. Entwürfe werden in Auswertungen nicht berücksichtigt. Neu gebuchte Einträge erhalten fortlaufende Buchungsnummern.',
        bookingDate: 'Buchungsdatum',
        documentDate: 'Belegdatum',
        taxDate: 'Steuerdatum',
        serviceDate: 'Leistungsdatum',
        description: 'Buchungstext',
        reference: 'Belegreferenz / Begründung',
        line: 'Zeile {{number}}',
        account: 'Konto',
        debit: 'Soll',
        credit: 'Haben',
        removeLine: 'Zeile entfernen',
        addLine: 'Zeile hinzufügen',
        dimensions: 'Kostenstelle und Kostenträger',
        costCenterId: 'Kostenstelle',
        costObjectId: 'Kostenträger',
        saveDraft: 'Entwurf speichern',
        post: 'Festschreiben',
        reverse: 'Gegenbuchung erstellen',
        immutableHint: 'Festgeschriebene Buchungen bleiben unverändert. Korrekturen erfolgen durch eine datierte Gegenbuchung mit Begründung.',
        reason: 'Begründung (mindestens 10 Zeichen)',
        status: 'Status',
        DRAFT: 'Entwurf',
        POSTED: 'Festgeschrieben',
        dateFrom: 'Von',
        dateTo: 'Bis / Stichtag',
        emptyJournal: 'Keine Buchungen für diese Auswahl. Erfasse einen Entwurf oder ändere die Filter.',
        reversalReference: 'Gegenbuchung zu',
        lines: 'Buchungszeilen anzeigen',
        chartHint: 'Konten werden mandantenbezogen gepflegt. Das Kontenblatt zeigt die zugehörigen Buchungen. Verwendete Kontotypen und Kontonummern bleiben geschützt.',
        newAccount: 'Sachkonto anlegen',
        journalNumber: 'Buchungsnummer',
        number: 'Kontonummer',
        name: 'Bezeichnung',
        currency: 'Kontowährung (optional)',
        kind: 'Kontoart',
        role: 'Verwendung',
        emptyAccounts: 'Keine Konten gefunden. Lege ein Konto an oder ändere die Suche.',
        accountSheet: 'Kontenblatt öffnen',
        periodHint: 'Gesperrte Perioden verhindern neue Buchungen. Offene Entwürfe müssen vorher geklärt werden. Eine Wiederöffnung erfordert ein eigenes Recht und eine protokollierte Begründung.',
        newYear: 'Geschäftsjahr anlegen',
        locked: 'Gesperrt',
        open: 'Offen',
        reopen: 'Wiederöffnen',
        lock: 'Periode sperren',
        report: 'Auswertung',
        reports: {
            trial: 'Summen- und Saldenliste',
            balance: 'Bilanz',
            profit: 'Gewinn und Verlust',
            bwa: 'Betriebswirtschaftliche Auswertung',
            tax: 'Umsatzsteuer und Vorsteuer',
        },
        metrics: {
            revenue: 'Erlöse im Zeitraum',
            expense: 'Aufwendungen im Zeitraum',
            profit: 'Ergebnis im Zeitraum',
            moneyBalance: 'Gebuchter Bank-/Kassenbestand',
        },
        bookingDateBasis: 'Buchungsdatum: Auswertungen und Kontenblätter verwenden den Buchungstag.',
        taxDateBasis: 'Steuerdatum: Übersicht, Kontenblatt und Export verwenden das festgehaltene Steuerdatum. Noch nicht fällige Umsatzsteuer bleibt getrennt.',
        reportDefinition: 'Auswertungen enthalten ausschließlich festgeschriebene Buchungszeilen. Erlöse und Aufwendungen sind keine Zahlungsströme. Salden enthalten den Vortrag vor dem gewählten Zeitraum; Soll und Haben zeigen die Bewegungen im Zeitraum. Kontolinks führen zu den Ursprungsbuchungen.',
        bwaDefinition: 'Definition dieser BWA: Erlöse abzüglich aller gebuchten Aufwendungen im gewählten Zeitraum, vor rein bilanziellen Geldbewegungen. Keine DATEV-Standard-BWA und keine Steuererklärung.',
        taxDefinition: 'Steuerkonten werden getrennt nach Vorsteuer, fälliger und noch nicht fälliger Umsatzsteuer gezeigt. Diese Kontenübersicht ist keine ELSTER-Übermittlung.',
        balanceTotals: 'Aktiva {{assets}} · Verbindlichkeiten {{liabilities}} · Eigenkapital {{equity}} · Periodenergebnis {{profit}}',
        balance: 'Saldo',
        balanced: 'Soll und Haben sind ausgeglichen.',
        unbalanced: 'Soll und Haben stimmen nicht überein.',
        errors: {
            vendorInvoiceCancelled: 'Diese Eingangsrechnungserfassung wurde bereits aufgehoben.',
            vendorInvoiceHasSettlements: 'Es bestehen Zahlungen, Skonti oder andere Ausgleiche. Prüfe diese zuerst und erfasse tatsächliche Lieferantengutschriften oder Erstattungen gesondert.',
            futureActualDate: 'Erfasse nur bereits erfolgte Vorgänge bis zum heutigen Tag des Mandanten. Zukünftige Zahlungstermine gehören in die Zahlungsplanung.',
            dependentCreditCorrection: 'Diese Zuordnung wurde bereits in einem festgeschriebenen Korrekturbeleg berücksichtigt. Prüfe den zusammenhängenden Vorgang vor einer Zahlungskorrektur; eine tatsächliche Rückzahlung ist eine neue Zahlung.',
            creditExceeded: 'Die Gutschrift überschreitet den noch nicht gutgeschriebenen Betrag der Ursprungsrechnung. Prüfe die bereits festgeschriebenen Korrekturbelege.',
            writeOffCreditTaxReview: 'Diese Teilgutschrift betrifft einen Forderungsausfall mit mehreren Steuersätzen. Die Steueraufteilung muss zuerst geprüft werden.',
            writeOffRecoveryInvalid: 'Wähle einen aktiven tatsächlichen Zahlungseingang desselben Kunden ab dem Ausbuchungsdatum. Eine falsche ursprüngliche Ausbuchung muss gesondert korrigiert werden.',
            writeOffSource: 'Nur gebuchte Ausgangsrechnungen mit positiver Forderung können ausgebucht werden.',
            writeOffTaxReview: 'Prüfe zuerst die steuerlichen Kurswerte und die Übernahme dieser Forderung.',
            writeOffDependent: 'Seit der Ausbuchung gibt es weitere Ausgleiche. Prüfe diese zuerst; die Ausbuchung kann so nicht aufgehoben werden.',
            journalOrder: 'Die Buchungsnummern sind nicht in der erwarteten Reihenfolge. Bitte wende dich an die Administration, bevor du erneut buchst.',
            accountMapping: 'Eine Kontenzuordnung fehlt oder ist mehrdeutig. Prüfe die Sachkonten und Buchhaltungseinstellungen.',
            taxRate: 'Die automatische Steuerkontierung ist für 7 % und 19 % eingerichtet. Andere Sätze benötigen eine gesondert geprüfte Kontierung.',
            rateEvidence: 'Bitte gib einen nachvollziehbaren Wechselkurs und seine Quelle an.',
            taxReview: 'Diese Verrechnung mit unterschiedlichen Steuersätzen bei Istversteuerung benötigt eine gesonderte steuerliche Behandlung.',
            allocationDate: 'Die Zuordnung darf nicht vor Zahlung oder Belegbuchung liegen. Prüfe auch spätere bestehende Zuordnungen.',
            discountInvalid: 'Skonto ist nicht vereinbart, die Zahlungsfrist ist abgelaufen oder der gesamte Abzug überschreitet die vereinbarten Konditionen. Maßgeblich ist das tatsächliche Zahlungsdatum.',
            transferDifference: 'Die Beträge eines Übertrags in derselben Währung müssen nach ausdrücklich erfassten Gebühren übereinstimmen.',
            offsetInvalid: 'Die Verrechnung braucht zwei aktive Zahlungen desselben Partners in entgegengesetzten Richtungen.',
            offsetCurrency: 'Bei gleicher Währung müssen die Beträge übereinstimmen. Bei verschiedenen Währungen sind beide Beträge und eine nachvollziehbare Umrechnungsquelle erforderlich.',
            offsetReverseFirst: 'Hebe zuerst die noch aktive Guthabenverrechnung im Zahlungsverlauf auf.',
            paymentExceeded: 'Der Ausgleichsbetrag übersteigt das verfügbare Zahlungsguthaben.',
            allocationExceeded: 'Die Zuordnung oder Skontokorrektur überschreitet den offenen beziehungsweise bereits ausgeglichenen Betrag.',
            adoptionRequired: 'Der Beleg muss zuerst gebucht oder über die geprüfte Eröffnung übernommen werden.',
            currencyFilter: 'Wähle vor dem Sortieren nach Betrag eine Währung aus.',
            taxBreakdown: 'Der Steuerausweis stimmt nicht mit den festgehaltenen Belegbeträgen überein.',
            financialFinalization: 'Bitte die Rechnung vor dem Versand festschreiben.',
            managedAccount: 'Forderungs- und Verbindlichkeitskonten werden über Rechnungen, Zahlungen und die geprüfte Eröffnung gebucht.',
            validation: 'Bitte prüfe die Pflichtangaben und Beträge. Ungültige Eingaben bleiben erhalten.',
            unbalanced: 'Soll und Haben müssen übereinstimmen; jede Buchungszeile benötigt einen Betrag.',
            periodLocked: 'Die Buchungsperiode fehlt, ist gesperrt oder gehört zu einem abgeschlossenen Geschäftsjahr.',
            immutable: 'Festgeschriebene Buchungen sind unveränderlich.',
            stale: 'Die Daten oder der verwendete Wiederholungsschlüssel haben sich geändert. Bitte neu laden und prüfen.',
            yearOverlap: 'Das Geschäftsjahr überschneidet sich mit einem vorhandenen Zeitraum.',
            setupRequired: 'Bitte richte zuerst die Buchhaltung ein.',
            alreadyConfigured: 'Die Buchhaltung ist bereits eingerichtet.',
            migrationRequired: 'Es gibt bereits Belege oder Zahlungen. Vor der Aktivierung ist eine geprüfte Bestandsübernahme erforderlich.',
            accountExists: 'Diese Kontonummer ist bereits vergeben.',
            accountInvalid: 'Mindestens ein Konto fehlt, ist inaktiv oder gehört zu einem anderen Mandanten.',
            sourceInvalid: 'Der zugeordnete Partner oder Beleg gehört nicht zu dieser Buchung.',
            dimensionInvalid: 'Kostenstelle oder Kostenträger fehlen oder sind inaktiv.',
            currencyMismatch: 'Die Währungen passen nicht zusammen. Eine ausdrückliche Umrechnung ist erforderlich.',
            beforeStart: 'Das Buchungsdatum liegt vor dem Buchhaltungsstart.',
            cannotReverse: 'Diese Buchung kann zu diesem Datum nicht gegengebucht werden.',
            reverseAtSource: 'Bitte korrigiere die Buchung am ursprünglichen Beleg oder Zahlungsvorgang.',
            yearClosed: 'Das Geschäftsjahr ist abgeschlossen.',
            draftsRemain: 'Die Periode enthält offene Entwürfe. Bitte prüfe diese zuerst.',
            dateRange: 'Das Enddatum muss nach dem Anfangsdatum liegen.',
            accountInUse: 'Kontonummer, Kontoart und Verwendung eines bereits verwendeten Kontos sind geschützt.',
            exportLimit: 'Die Auswahl enthält zu viele Zeilen für einen Export. Bitte grenze den Zeitraum oder die Konten ein.',
        },
        kindLabels: {
            ASSET: 'Aktiva',
            LIABILITY: 'Verbindlichkeiten',
            EQUITY: 'Eigenkapital',
            REVENUE: 'Erlös',
            EXPENSE: 'Aufwand',
        },
        roleLabels: {
            ADVANCE_RECEIVED: 'Erhaltene Anzahlungen',
            ADVANCE_PAID: 'Geleistete Anzahlungen',
            TRANSFER_CLEARING: 'Eigene Kontoüberträge',
            BAD_DEBT: 'Forderungsausfälle',
            GENERAL: 'Sachkonto',
            RECEIVABLE: 'Forderungen',
            PAYABLE: 'Verbindlichkeiten',
            BANK: 'Bank',
            CASH: 'Kasse',
            CLEARING: 'Verrechnung',
            OUTPUT_TAX: 'Umsatzsteuer',
            INPUT_TAX: 'Vorsteuer',
            DEFERRED_TAX: 'Nicht fällige Steuer',
            DISCOUNT: 'Skonto',
            FEE: 'Gebühren',
            FX: 'Kursdifferenzen',
            OPENING: 'Eröffnung',
            RETAINED_EARNINGS: 'Gewinnvortrag',
        },
        code: 'Kennung',
        originalCurrency: 'Originalwährung',
        originalAmount: 'Originalbetrag',
        exchangeRate: 'Kurs zur Buchhaltungswährung',
        fxHint: 'Bei Fremdwährung sind Originalbetrag, Währung und der ausdrücklich verwendete Kurs gemeinsam erforderlich. Soll und Haben bleiben Beträge in der Buchhaltungswährung.',
        none: 'Keine Zuordnung',
        opening: 'Vortrag',
        currencyCode: 'Währung',
        exportJournal: 'Journal als CSV exportieren',
        exportBalances: 'Summen und Salden als CSV exportieren',
        exportHint: 'Der Journalexport berücksichtigt die Filter. Ohne Statusauswahl werden nur festgeschriebene Buchungen exportiert.',
        permissionActions: {
            EXECUTE: 'Forderungsausfälle buchen',
            READ: 'Buchhaltung lesen',
            CREATE: 'Entwürfe erfassen',
            UPDATE: 'Entwürfe bearbeiten',
            APPROVE: 'Buchungen festschreiben',
            ARCHIVE: 'Gegenbuchungen erstellen',
            COMPLETE: 'Perioden abschließen',
            RELEASE: 'Perioden wiederöffnen',
            MANAGE_SETTINGS: 'Buchhaltung einrichten',
            EXPORT: 'Buchhaltung exportieren',
        },
    },
    en: {
        selfAssessment: apSelfAssessmentTranslations.en,
        unsavedTitle: 'Unsaved changes',
        unsavedHint: 'Your inputs have not been saved. Do you want to discard them?',
        discard: 'Discard changes',
        vendorAllocation: {
            matchRequired: 'Run invoice matching first, then reopen this preview.',
            title: 'Account assignment and posting',
            hint: 'Check the original, allocate amounts to expense or asset accounts and review the posting before approval. Original amounts are retained.',
            rate: 'Exchange rate',
            zero: 'The original has a zero amount. No payment or journal entry is created.',
            saved: 'Account assignment saved. Review the new posting preview.',
            amountHint: 'Allocate net amounts in {{currency}}. Use a point or comma as the decimal separator without thousands separators. Non-deductible input VAT increases the expense or acquisition cost.',
            row: 'Allocation {{number}}',
            account: 'Ledger account {{number}}',
            netAmount: 'Net amount {{number}}',
            taxRate: 'Tax rate % {{number}}',
            inputTaxDeductionPercent: 'Input VAT deduction % {{number}}',
            costCenterId: 'Cost center {{number}}',
            costObjectId: 'Cost object {{number}}',
            description: 'Posting text {{number}}',
            remove: 'Remove allocation {{number}}',
            rowResult: 'Deductible input VAT: {{deductible}} · Expense/acquisition cost: {{cost}}',
            add: 'Add allocation',
            save: 'Save account assignment',
            edit: 'Edit account assignment',
            dimensions: 'Cost center / cost object',
            reason: 'Reason for discrepancies',
            checked: 'Original and account assignment checked',
            approve: 'Approve and post reviewed invoice',
            refresh: 'Refresh preview',
            findings: {
                invalidInput: 'Check all highlighted entries. Enter amounts without thousands separators.',
                duplicatePosition: 'Each allocation needs a unique position.',
                allocationTotalMismatch: 'The allocation for each tax rate must equal the original net amount.',
                allocationTaxRateMismatch: 'This allocation tax rate is absent from the original.',
                allocationSignMismatch: 'An allocation cannot reverse the original amount sign.',
                zeroTaxBase: 'Tax without a matching net base requires a separate review.',
                sourceTaxMismatch: 'The tax amounts cannot be allocated unambiguously to the original.',
                amountOverflow: 'The calculated amount exceeds the permitted range.',
                invoiceNotEditable: 'This invoice has already been approved or cancelled. The recorded assignment is retained.',
                allocationMissing: 'The selected account assignment is missing. Review the allocation.',
                costAccountInvalid: 'Select an active expense, inventory or asset account in the book currency. Money, tax and control accounts are not allowed here.',
                dimensionInvalid: 'Select an active cost center or cost object of this business.',
                reviewRequired: 'Review and confirm the current posting preview before approval.',
                serviceDateAssumed: 'No separate service date is recorded. The review uses the invoice date; check it against the original.',
            },
        },
        vendorCorrection: {
            recorded: 'Recorded correction',
            author: 'Recorded by',
            title: 'Erroneous incoming invoice registration',
            open: 'Review registration',
            post: 'Cancel registration',
            evidence: 'Correction evidence',
            review: 'Review evidence again',
            hint: 'Correct a mistaken registration with a date, reason and evidence. Actual payments and supplier credits are recorded separately. The original document and journal remain intact.',
            taxHint: 'Tax-relevant registration corrections affect the original tax period. A later booking date does not bypass its lock.',
            sourceChanged: 'The evidence has changed. Review it again before posting the correction.',
            permission: 'A posted incoming invoice also requires the separate ledger reversal permission.',
            unbooked: 'This registration has not yet been posted to the ledger. Cancelling it creates no journal entry.',
            taxDate: 'Original journal tax date',
            correctionJournal: 'Reversal journal',
            saved: 'Registration cancelled with traceable evidence.',
        },
        writeOff: {
            recover: 'Allocate a later receipt',
            recoveryHint: 'Select an existing actual receipt for the same customer. The receivable is restored for this amount and immediately cleared with that payment. No additional cash movement is created. Tax follows the actual receipt date.',
            recoverable: 'Remaining written-off amount',
            noReceipts: 'No matching receipts with available balances on or after the loss date. Record the actual receipt under Payments first.',
            recoveryReason: 'Later actual receipt allocated to a previously written-off receivable',
            recoveryAmount: 'Amount to allocate',
            recoverySave: 'Allocate payment and restore receivable',
            recoveryReview: 'Review payment and write-off again',
            recoveryReviewed: 'Remaining balances and evidence updated. Review amount and date before saving.',
            receiptLink: 'Open existing payment',
            title: 'Receivable write-offs',
            review: 'Review receivable write-off',
            hint: 'Records a justified receivable loss without a cash receipt. Review evidence of uncollectibility and the tax treatment before posting.',
            amount: 'Gross amount to write off',
            evidence: 'Evidence of uncollectibility',
            account: 'Bad-debt expense account',
            selectAccount: 'Select account',
            noAccount: 'Create an expense account with the Bad debt role under Ledger accounts.',
            confirm: 'Uncollectibility and tax treatment reviewed',
            preview: 'Calculate preview',
            post: 'Post write-off',
            tax: 'Tax correction',
            expense: 'Expense',
            reverse: 'Reverse incorrect write-off',
            reverseHint: 'Corrects an incorrectly recorded write-off. The original tax period must be open. An actual later recovery requires its own settlement and tax correction.',
            recorded: 'Written off',
            reversed: 'Write-off reversed',
            empty: 'This receivable has no write-offs yet.',
        },
        documentDefaultsHint: 'Without overrides, the ERP derives posting and tax dates from the document type, document date and service date. The exchange rate is the ledger-currency value of one document-currency unit. The rate source stays internal.',
        views: {
            overview: 'Finance / accounting',
            journal: 'Journal',
            accounts: 'Ledger accounts',
            reports: 'Reports',
            periods: 'Fiscal years and periods',
        },
        subtitle: 'Record, review and trace entries with supporting evidence.',
        navigation: 'Accounting sections',
        help: 'Accounting help',
        forbidden: 'You do not have permission to view accounting.',
        setup: 'Set up accounting',
        setupHint: 'Choose the accounting start. Existing invoices or payments require a reviewed opening migration first. The small starter chart is editable and is not a complete DATEV chart.',
        startDate: 'Accounting start',
        vatMethod: 'VAT accounting method',
        ACCRUAL: 'Accrual VAT',
        CASH: 'Cash VAT (authorization required)',
        saved: 'Saved.',
        newJournal: 'New journal entry',
        journalHint: 'All amounts use the accounting currency. Each line contains a debit or a credit. Drafts are excluded from reports. Newly posted entries receive consecutive journal numbers.',
        bookingDate: 'Posting date',
        documentDate: 'Document date',
        taxDate: 'Tax date',
        serviceDate: 'Service date',
        description: 'Entry description',
        reference: 'Evidence reference / justification',
        line: 'Line {{number}}',
        account: 'Account',
        debit: 'Debit',
        credit: 'Credit',
        removeLine: 'Remove line',
        addLine: 'Add line',
        dimensions: 'Cost center and cost object',
        costCenterId: 'Cost center',
        costObjectId: 'Cost object',
        saveDraft: 'Save draft',
        post: 'Post permanently',
        reverse: 'Create reversal',
        immutableHint: 'Posted entries remain unchanged. Corrections require a dated reversal with a reason.',
        reason: 'Reason (at least 10 characters)',
        status: 'Status',
        DRAFT: 'Draft',
        POSTED: 'Posted',
        dateFrom: 'From',
        dateTo: 'To / reporting date',
        emptyJournal: 'No entries match these filters. Create a draft or adjust the filters.',
        reversalReference: 'Reversal of',
        lines: 'Show entry lines',
        chartHint: 'Accounts belong to this tenant. Account sheets show their entries. Used account types and numbers are protected.',
        newAccount: 'Create ledger account',
        journalNumber: 'Entry number',
        number: 'Account number',
        name: 'Name',
        currency: 'Account currency (optional)',
        kind: 'Account type',
        role: 'Purpose',
        emptyAccounts: 'No accounts found. Create an account or change the search.',
        accountSheet: 'Open account sheet',
        periodHint: 'Locked periods prevent new postings. Resolve drafts before closing. Reopening requires separate permission and a recorded reason.',
        newYear: 'Create fiscal year',
        locked: 'Locked',
        open: 'Open',
        reopen: 'Reopen',
        lock: 'Lock period',
        report: 'Report',
        reports: {
            trial: 'Trial balance',
            balance: 'Balance sheet',
            profit: 'Profit and loss',
            bwa: 'Management statement',
            tax: 'Output and input VAT',
        },
        metrics: {
            revenue: 'Period revenue',
            expense: 'Period expenses',
            profit: 'Period result',
            moneyBalance: 'Posted bank/cash balance',
        },
        bookingDateBasis: 'Booking date: reports and account sheets use the posting day.',
        taxDateBasis: 'Tax date: the report, account drilldown and export use the frozen tax day. Deferred output VAT remains separate.',
        reportDefinition: 'Reports contain only posted lines. Revenue and expenses are not cash flows. Balances include carry-in before the chosen period; debit and credit show period movements. Account links open source entries.',
        bwaDefinition: 'This management statement is period revenue less all posted period expenses, excluding balance-sheet-only cash movements. It is not a standard DATEV BWA or a tax return.',
        taxDefinition: 'Tax accounts distinguish input VAT, output VAT due and deferred output VAT. This account view does not submit an ELSTER return.',
        balanceTotals: 'Assets {{assets}} · Liabilities {{liabilities}} · Equity {{equity}} · Period result {{profit}}',
        balance: 'Balance',
        balanced: 'Debit and credit balance.',
        unbalanced: 'Debit and credit do not balance.',
        errors: {
            vendorInvoiceCancelled: 'This incoming invoice registration has already been cancelled.',
            vendorInvoiceHasSettlements: 'Payments, cash discounts or other settlements exist. Review them first and record actual supplier credits or refunds separately.',
            futureActualDate: 'Record only completed events up to the tenant’s current business day. Future payment dates belong in payment planning.',
            dependentCreditCorrection: 'This allocation has already been included in a posted correction document. Review the related transaction before correcting the payment; an actual repayment is a new payment.',
            creditExceeded: 'This credit exceeds the original invoice amount that has not already been credited. Review its posted correction documents.',
            writeOffCreditTaxReview: 'This partial credit affects a receivable loss with multiple tax rates. Review the tax split first.',
            writeOffRecoveryInvalid: 'Select an active actual receipt for the same customer dated on or after the write-off. An incorrect original write-off requires a separate correction.',
            writeOffSource: 'Only posted sales invoices with a positive receivable can be written off.',
            writeOffTaxReview: 'Review the fiscal exchange rates and adoption of this receivable first.',
            writeOffDependent: 'Further settlements exist after this write-off. Review them first; this write-off cannot be reversed in its current state.',
            journalOrder: 'Journal numbers are not in the expected order. Contact your administrator before posting again.',
            accountMapping: 'An account mapping is missing or ambiguous. Check the ledger accounts and accounting settings.',
            taxRate: 'Automatic tax accounts are configured for 7% and 19%. Other rates require separately reviewed account assignments.',
            rateEvidence: 'Enter a verifiable exchange rate and its source.',
            taxReview: 'This offset with differing VAT rates under cash VAT requires separate tax treatment.',
            allocationDate: 'Allocation cannot precede cash or invoice recognition. Also check later existing allocations.',
            discountInvalid: 'Cash discount is not agreed, its payment deadline has passed, or the cumulative deduction exceeds the agreed terms. The actual cash date applies.',
            transferDifference: 'For a transfer in the same currency, amounts must agree after explicitly recorded fees.',
            offsetInvalid: 'Setoff requires two active payments of the same partner in opposite directions.',
            offsetCurrency: 'Amounts must agree in the same currency. Different currencies require both explicit amounts and a verifiable conversion source.',
            offsetReverseFirst: 'First reverse the active credit setoff in the payment history.',
            paymentExceeded: 'The settlement exceeds the available payment credit.',
            allocationExceeded: 'The allocation or discount correction exceeds the open or already settled amount.',
            adoptionRequired: 'Post the invoice or adopt it through reviewed opening balances first.',
            currencyFilter: 'Select one currency before sorting by amount.',
            taxBreakdown: 'The tax breakdown differs from the frozen invoice amounts.',
            financialFinalization: 'Post the invoice permanently before sending it.',
            managedAccount: 'Receivable and payable accounts are posted through invoices, payments and reviewed opening balances.',
            validation: 'Check required fields and amounts. Your entries are retained.',
            unbalanced: 'Debit and credit must balance; every line needs an amount.',
            periodLocked: 'The posting period is missing, locked or belongs to a closed fiscal year.',
            immutable: 'Posted entries are immutable.',
            stale: 'The data or replay key has changed. Reload and review.',
            yearOverlap: 'The fiscal year overlaps an existing period.',
            setupRequired: 'Set up accounting first.',
            alreadyConfigured: 'Accounting is already configured.',
            migrationRequired: 'Invoices or payments already exist. A reviewed opening migration is required before activation.',
            accountExists: 'This account number already exists.',
            accountInvalid: 'An account is missing, inactive or belongs to another tenant.',
            sourceInvalid: 'The linked partner or document does not belong to this entry.',
            dimensionInvalid: 'The cost center or cost object is missing or inactive.',
            currencyMismatch: 'Currencies do not match. An explicit conversion is required.',
            beforeStart: 'The posting date is before the accounting start.',
            cannotReverse: 'This entry cannot be reversed on this date.',
            reverseAtSource: 'Correct this entry through its original document or payment.',
            yearClosed: 'The fiscal year is closed.',
            draftsRemain: 'This period contains drafts. Review them first.',
            dateRange: 'The end date must not precede the start date.',
            accountInUse: 'The number, type and purpose of an account already in use are protected.',
            exportLimit: 'The selection contains too many export rows. Narrow the period or accounts.',
        },
        kindLabels: {
            ASSET: 'Asset',
            LIABILITY: 'Liability',
            EQUITY: 'Equity',
            REVENUE: 'Revenue',
            EXPENSE: 'Expense',
        },
        roleLabels: {
            ADVANCE_RECEIVED: 'Customer advances',
            ADVANCE_PAID: 'Supplier advances',
            TRANSFER_CLEARING: 'Own account transfers',
            BAD_DEBT: 'Bad debts',
            GENERAL: 'General',
            RECEIVABLE: 'Receivables',
            PAYABLE: 'Payables',
            BANK: 'Bank',
            CASH: 'Cash',
            CLEARING: 'Clearing',
            OUTPUT_TAX: 'Output VAT',
            INPUT_TAX: 'Input VAT',
            DEFERRED_TAX: 'Deferred tax',
            DISCOUNT: 'Cash discount',
            FEE: 'Fees',
            FX: 'Exchange differences',
            OPENING: 'Opening balance',
            RETAINED_EARNINGS: 'Retained earnings',
        },
        code: 'Code',
        originalCurrency: 'Original currency',
        originalAmount: 'Original amount',
        exchangeRate: 'Rate to accounting currency',
        fxHint: 'For foreign currency, enter the original amount, currency and explicit rate together. Debit and credit remain in the accounting currency.',
        none: 'No assignment',
        opening: 'Opening balance',
        currencyCode: 'Currency',
        exportJournal: 'Export journal as CSV',
        exportBalances: 'Export trial balance as CSV',
        exportHint: 'The journal export follows the filters. Without a status selection, only posted entries are exported.',
        permissionActions: {
            EXECUTE: 'Post receivable write-offs',
            READ: 'View accounting',
            CREATE: 'Create drafts',
            UPDATE: 'Edit drafts',
            APPROVE: 'Post entries',
            ARCHIVE: 'Create reversals',
            COMPLETE: 'Close periods',
            RELEASE: 'Reopen periods',
            MANAGE_SETTINGS: 'Configure accounting',
            EXPORT: 'Export accounting',
        },
    },
    tr: {
        selfAssessment: apSelfAssessmentTranslations.tr,
        unsavedTitle: 'Kaydedilmemiş değişiklikler',
        unsavedHint: 'Girdileriniz henüz kaydedilmedi. Değişiklikleri iptal etmek istiyor musunuz?',
        discard: 'Değişiklikleri iptal et',
        vendorAllocation: {
            matchRequired: 'Önce fatura karşılaştırmasını çalıştırın, ardından bu önizlemeyi yeniden açın.',
            title: 'Hesap dağılımı ve muhasebeleştirme',
            hint: 'Asıl belgeyi kontrol edin, tutarları gider veya varlık hesaplarına dağıtın ve onaydan önce muhasebe kaydını inceleyin. Asıl tutarlar korunur.',
            rate: 'Döviz kuru',
            zero: 'Asıl belgenin tutarı sıfırdır. Ödeme veya yevmiye kaydı oluşturulmaz.',
            saved: 'Hesap dağılımı kaydedildi. Yeni kayıt önizlemesini kontrol edin.',
            amountHint: 'Net tutarları {{currency}} cinsinden dağıtın. Ondalık ayırıcı olarak nokta veya virgül kullanın; binlik ayırıcı kullanmayın. İndirilemeyen KDV, gideri veya edinim maliyetini artırır.',
            row: 'Dağılım {{number}}',
            account: 'Muhasebe hesabı {{number}}',
            netAmount: 'Net tutar {{number}}',
            taxRate: 'Vergi oranı % {{number}}',
            inputTaxDeductionPercent: 'İndirilecek KDV oranı % {{number}}',
            costCenterId: 'Masraf merkezi {{number}}',
            costObjectId: 'Maliyet nesnesi {{number}}',
            description: 'Kayıt açıklaması {{number}}',
            remove: 'Dağılım {{number}} kaldır',
            rowResult: 'İndirilebilir KDV: {{deductible}} · Gider/edinim maliyeti: {{cost}}',
            add: 'Dağılım ekle',
            save: 'Hesap dağılımını kaydet',
            edit: 'Hesap dağılımını düzenle',
            dimensions: 'Masraf merkezi / maliyet nesnesi',
            reason: 'Farklar için gerekçe',
            checked: 'Asıl belge ve hesap dağılımı kontrol edildi',
            approve: 'Kontrol edilen faturayı onayla ve kaydet',
            refresh: 'Önizlemeyi yenile',
            findings: {
                invalidInput: 'İşaretli alanları kontrol edin. Tutarları binlik ayırıcı olmadan girin.',
                duplicatePosition: 'Her dağılım için benzersiz bir sıra gereklidir.',
                allocationTotalMismatch: 'Her vergi oranındaki dağılım, asıl belgenin net tutarına eşit olmalıdır.',
                allocationTaxRateMismatch: 'Dağılımın vergi oranı asıl belgede bulunmuyor.',
                allocationSignMismatch: 'Dağılım, asıl tutarın işaretini tersine çeviremez.',
                zeroTaxBase: 'Uygun net matrahı olmayan vergi ayrıca incelenmelidir.',
                sourceTaxMismatch: 'Vergi tutarları asıl belgeye kesin olarak dağıtılamıyor.',
                amountOverflow: 'Hesaplanan tutar izin verilen aralığı aşıyor.',
                invoiceNotEditable: 'Bu fatura onaylanmış veya iptal edilmiştir. Kaydedilen hesap dağılımı korunur.',
                allocationMissing: 'Seçilen hesap dağılımı eksik. Dağılımı yeniden kontrol edin.',
                costAccountInvalid: 'Muhasebe para biriminde etkin bir gider, stok veya varlık hesabı seçin. Para, vergi ve kontrol hesapları burada kullanılamaz.',
                dimensionInvalid: 'Bu işletmeye ait etkin bir masraf merkezi veya maliyet nesnesi seçin.',
                reviewRequired: 'Onaydan önce güncel muhasebe önizlemesini kontrol edip doğrulayın.',
                serviceDateAssumed: 'Ayrı bir hizmet tarihi kaydedilmemiş. Kontrol için fatura tarihi kullanılır; asıl belgeyle karşılaştırın.',
            },
        },
        vendorCorrection: {
            recorded: 'Kaydedilmiş düzeltme',
            author: 'İşlemi yapan',
            title: 'Hatalı alış faturası kaydı',
            open: 'Kaydı incele',
            post: 'Kaydı iptal et',
            evidence: 'Düzeltme kanıtı',
            review: 'Kanıtları yeniden incele',
            hint: 'Hatalı kaydı tarih, gerekçe ve kanıtla düzeltin. Gerçek ödemeler ve tedarikçi alacak dekontları ayrı kaydedilir. Asıl belge ve yevmiye kaydı korunur.',
            taxHint: 'Vergiyi etkileyen kayıt düzeltmeleri asıl vergi dönemine aittir. Sonraki bir muhasebe tarihi bu dönemin kilidini aşmaz.',
            sourceChanged: 'Kanıtlar değişti. Düzeltmeyi kesinleştirmeden önce yeniden inceleyin.',
            permission: 'Muhasebeleştirilmiş alış faturası için ayrıca yevmiye kaydını ters çevirme yetkisi gerekir.',
            unbooked: 'Bu kayıt henüz büyük deftere işlenmemiştir. İptal edilmesi yevmiye kaydı oluşturmaz.',
            taxDate: 'Asıl yevmiye kaydının vergi tarihi',
            correctionJournal: 'Ters yevmiye kaydı',
            saved: 'Kayıt izlenebilir kanıtlarla iptal edildi.',
        },
        writeOff: {
            recover: 'Sonraki tahsilatı eşleştir',
            recoveryHint: 'Aynı müşterinin mevcut gerçek tahsilatını seçin. Alacak bu tutar kadar yeniden oluşturulur ve ödemeyle hemen kapatılır. Yeni para hareketi oluşmaz. Vergi için gerçek tahsilat tarihi esas alınır.',
            recoverable: 'Gider yazılmış kalan tutar',
            noReceipts: 'Gider yazma tarihinden itibaren uygun, kalan tutarlı tahsilat yok. Önce Ödemeler bölümünde gerçek tahsilatı kaydedin.',
            recoveryReason: 'Sonraki gerçek tahsilat önceden gider yazılmış alacakla eşleştirildi',
            recoveryAmount: 'Eşleştirilecek tutar',
            recoverySave: 'Ödemeyi eşleştir ve alacağı geri oluştur',
            recoveryReview: 'Ödemeyi ve gider kaydını yeniden incele',
            recoveryReviewed: 'Kalan tutarlar ve kanıtlar güncellendi. Kaydetmeden önce tutarı ve tarihi inceleyin.',
            receiptLink: 'Mevcut ödemeyi aç',
            title: 'Tahsil edilemeyen alacaklar',
            review: 'Alacak kaybını incele',
            hint: 'Para girişi olmadan gerekçeli alacak kaydını oluşturur. Kesinleştirmeden önce tahsil edilememe kanıtını ve vergi işlemini inceleyin.',
            amount: 'Gider yazılacak brüt tutar',
            evidence: 'Tahsil edilememe kanıtı',
            account: 'Tahsil edilemeyen alacak gider hesabı',
            selectAccount: 'Hesap seçin',
            noAccount: 'Büyük defter hesaplarında Tahsil edilemeyen alacak kullanımında bir gider hesabı oluşturun.',
            confirm: 'Tahsil edilememe ve vergi işlemi incelendi',
            preview: 'Önizlemeyi hesapla',
            post: 'Gider kaydını kesinleştir',
            tax: 'Vergi düzeltmesi',
            expense: 'Gider',
            reverse: 'Hatalı gider kaydını geri al',
            reverseHint: 'Hatalı alacak kaydını düzeltir. Asıl vergi dönemi açık olmalıdır. Sonradan gerçekten tahsil edilen alacak için ayrı kapatma ve vergi düzeltmesi gerekir.',
            recorded: 'Gider yazıldı',
            reversed: 'Gider kaydı geri alındı',
            empty: 'Bu alacak için henüz gider kaydı yok.',
        },
        documentDefaultsHint: 'Farklı değer girilmezse ERP kayıt ve vergi tarihini belge türü, belge tarihi ve hizmet tarihinden belirler. Kur, bir belge para biriminin muhasebe para birimindeki değeridir. Kur kaynağı dahili kalır.',
        views: {
            overview: 'Finans / muhasebe',
            journal: 'Muhasebe günlüğü',
            accounts: 'Büyük defter hesapları',
            reports: 'Raporlar',
            periods: 'Mali yıllar ve dönemler',
        },
        subtitle: 'Belgelere dayalı kayıtları oluşturun, kontrol edin ve izleyin.',
        navigation: 'Muhasebe bölümleri',
        help: 'Muhasebe yardımı',
        forbidden: 'Muhasebeyi görüntüleme yetkiniz yok.',
        setup: 'Muhasebeyi ayarla',
        setupHint: 'Muhasebe başlangıcını seçin. Mevcut fatura veya ödemeler önce kontrol edilmiş bir devir gerektirir. Küçük başlangıç hesap planı genişletilebilir; tam bir DATEV planı değildir.',
        startDate: 'Muhasebe başlangıcı',
        vatMethod: 'KDV yöntemi',
        ACCRUAL: 'Tahakkuk esaslı KDV',
        CASH: 'Tahsilat esaslı KDV (izin gerekir)',
        saved: 'Kaydedildi.',
        newJournal: 'Yeni muhasebe kaydı',
        journalHint: 'Tüm tutarlar muhasebe para birimindedir. Her satır borç veya alacak içerir. Taslaklar raporlara dahil edilmez. Yeni onaylanan kayıtlara sıralı numara verilir.',
        bookingDate: 'Kayıt tarihi',
        documentDate: 'Belge tarihi',
        taxDate: 'Vergi tarihi',
        serviceDate: 'Hizmet tarihi',
        description: 'Kayıt açıklaması',
        reference: 'Belge referansı / gerekçe',
        line: 'Satır {{number}}',
        account: 'Hesap',
        debit: 'Borç',
        credit: 'Alacak',
        removeLine: 'Satırı kaldır',
        addLine: 'Satır ekle',
        dimensions: 'Masraf merkezi ve maliyet nesnesi',
        costCenterId: 'Masraf merkezi',
        costObjectId: 'Maliyet nesnesi',
        saveDraft: 'Taslağı kaydet',
        post: 'Kesinleştir',
        reverse: 'Ters kayıt oluştur',
        immutableHint: 'Kesinleşen kayıtlar değişmez. Düzeltmeler gerekçeli ve tarihli bir ters kayıt gerektirir.',
        reason: 'Gerekçe (en az 10 karakter)',
        status: 'Durum',
        DRAFT: 'Taslak',
        POSTED: 'Kesinleşti',
        dateFrom: 'Başlangıç',
        dateTo: 'Bitiş / rapor tarihi',
        emptyJournal: 'Bu filtrelere uygun kayıt yok. Taslak oluşturun veya filtreleri değiştirin.',
        reversalReference: 'Ters kaydı',
        lines: 'Kayıt satırlarını göster',
        chartHint: 'Hesaplar bu şirkete aittir. Hesap dökümü ilgili kayıtları gösterir. Kullanılan hesap türleri ve numaraları korunur.',
        newAccount: 'Büyük defter hesabı oluştur',
        journalNumber: 'Kayıt numarası',
        number: 'Hesap numarası',
        name: 'Ad',
        currency: 'Hesap para birimi (isteğe bağlı)',
        kind: 'Hesap türü',
        role: 'Kullanım',
        emptyAccounts: 'Hesap bulunamadı. Hesap oluşturun veya aramayı değiştirin.',
        accountSheet: 'Hesap dökümünü aç',
        periodHint: 'Kilitli dönemlerde yeni kayıt yapılamaz. Kapanıştan önce taslakları çözün. Yeniden açmak ayrı yetki ve kayıtlı gerekçe gerektirir.',
        newYear: 'Mali yıl oluştur',
        locked: 'Kilitli',
        open: 'Açık',
        reopen: 'Yeniden aç',
        lock: 'Dönemi kilitle',
        report: 'Rapor',
        reports: {
            trial: 'Mizan',
            balance: 'Bilanço',
            profit: 'Kâr ve zarar',
            bwa: 'İşletme raporu',
            tax: 'Hesaplanan ve indirilecek KDV',
        },
        metrics: {
            revenue: 'Dönem gelirleri',
            expense: 'Dönem giderleri',
            profit: 'Dönem sonucu',
            moneyBalance: 'Kayıtlı banka/kasa bakiyesi',
        },
        bookingDateBasis: 'Kayıt tarihi: raporlar ve hesap dökümleri muhasebe gününü kullanır.',
        taxDateBasis: 'Vergi tarihi: rapor, hesap ayrıntıları ve dışa aktarım sabitlenmiş vergi gününü kullanır. Henüz doğmamış KDV ayrı tutulur.',
        reportDefinition: 'Raporlar yalnızca kesinleşmiş satırları içerir. Gelir ve giderler nakit akışı değildir. Bakiyeler dönem öncesi devri içerir; borç ve alacak dönem hareketleridir. Hesap bağlantıları kaynak kayıtları açar.',
        bwaDefinition: 'Bu işletme raporu, bilanço içi nakit hareketlerini hariç tutarak dönem gelirlerinden kayıtlı dönem giderlerini çıkarır. Standart DATEV BWA veya vergi beyannamesi değildir.',
        taxDefinition: 'Vergi hesapları indirilecek, ödenecek ve henüz vadesi gelmemiş KDV’yi ayırır. Bu görünüm ELSTER beyanı göndermez.',
        balanceTotals: 'Varlıklar {{assets}} · Borçlar {{liabilities}} · Özkaynak {{equity}} · Dönem sonucu {{profit}}',
        balance: 'Bakiye',
        balanced: 'Borç ve alacak dengede.',
        unbalanced: 'Borç ve alacak dengede değil.',
        errors: {
            vendorInvoiceCancelled: 'Bu alış faturası kaydı zaten iptal edilmiş.',
            vendorInvoiceHasSettlements: 'Ödemeler, iskontolar veya başka kapatmalar var. Önce bunları inceleyin; gerçek tedarikçi alacak dekontlarını veya iadelerini ayrı kaydedin.',
            futureActualDate: 'Yalnızca firmanın bugünkü iş gününe kadar gerçekleşmiş işlemleri kaydedin. Gelecekteki ödeme tarihleri ödeme planlamasına aittir.',
            dependentCreditCorrection: 'Bu eşleştirme kesinleşmiş bir düzeltme belgesinde zaten dikkate alınmıştır. Ödemeyi düzeltmeden önce bağlantılı işlemi inceleyin; fiili iade yeni bir ödemedir.',
            creditExceeded: 'Alacak dekontu asıl faturanın daha önce alacaklandırılmamış tutarını aşıyor. Kesinleşmiş düzeltme belgelerini inceleyin.',
            writeOffCreditTaxReview: 'Bu kısmi alacak dekontu birden çok vergi oranı içeren alacak zararını etkiliyor. Önce vergi dağılımını inceleyin.',
            writeOffRecoveryInvalid: 'Aynı müşterinin gider yazma tarihinde veya sonrasında gerçekleşmiş etkin tahsilatını seçin. Hatalı asıl gider kaydı ayrı olarak düzeltilmelidir.',
            writeOffSource: 'Yalnızca muhasebeleştirilmiş ve pozitif alacağı olan satış faturaları gider yazılabilir.',
            writeOffTaxReview: 'Önce bu alacağın vergi kurlarını ve devrini inceleyin.',
            writeOffDependent: 'Gider kaydından sonra başka kapatmalar var. Geri almadan önce bunları inceleyin.',
            journalOrder: 'Muhasebe kayıt numaraları beklenen sırada değil. Yeniden kayıt yapmadan önce yöneticinize başvurun.',
            accountMapping: 'Hesap eşleştirmesi eksik veya belirsiz. Büyük defter hesaplarını ve muhasebe ayarlarını kontrol edin.',
            taxRate: 'Otomatik vergi hesapları %7 ve %19 için tanımlıdır. Diğer oranlar ayrıca kontrol edilmiş kontasyon gerektirir.',
            rateEvidence: 'Doğrulanabilir döviz kurunu ve kaynağını girin.',
            taxReview: 'Tahsil esaslı KDV kapsamında farklı oranların bu mahsubu ayrıca vergi incelemesi gerektirir.',
            allocationDate: 'Eşleştirme, ödeme veya fatura kaydından önce olamaz. Daha sonraki eşleştirmeleri de kontrol edin.',
            discountInvalid: 'İskonto kararlaştırılmamış, ödeme süresi geçmiş veya toplam indirim kararlaştırılan koşulları aşıyor. Gerçek ödeme tarihi esas alınır.',
            transferDifference: 'Aynı para birimindeki aktarımlarda tutarlar, açıkça kaydedilen ücretlerden sonra eşit olmalıdır.',
            offsetInvalid: 'Mahsup için aynı tarafın ters yönlerde iki etkin ödemesi gerekir.',
            offsetCurrency: 'Aynı para biriminde tutarlar eşit olmalıdır. Farklı para birimlerinde iki açık tutar ve doğrulanabilir dönüşüm kaynağı gerekir.',
            offsetReverseFirst: 'Önce ödeme geçmişindeki etkin bakiye mahsubunu iptal edin.',
            paymentExceeded: 'Kapama tutarı kullanılabilir ödeme bakiyesini aşıyor.',
            allocationExceeded: 'Eşleştirme veya iskonto düzeltmesi açık ya da kapatılmış tutarı aşıyor.',
            adoptionRequired: 'Önce faturayı kaydedin veya kontrol edilmiş açılış devrine alın.',
            currencyFilter: 'Tutara göre sıralamadan önce para birimi seçin.',
            taxBreakdown: 'Vergi dağılımı sabitlenmiş fatura tutarlarıyla uyuşmuyor.',
            financialFinalization: 'Göndermeden önce faturayı kesinleştirin.',
            managedAccount: 'Alacak ve borç hesapları fatura, ödeme ve kontrol edilmiş açılış bakiyeleri üzerinden kaydedilir.',
            validation: 'Zorunlu alanları ve tutarları kontrol edin. Girdileriniz korunur.',
            unbalanced: 'Borç ve alacak eşit olmalı; her satır bir tutar gerektirir.',
            periodLocked: 'Kayıt dönemi eksik, kilitli veya kapalı bir mali yıla ait.',
            immutable: 'Kesinleşmiş kayıtlar değiştirilemez.',
            stale: 'Veriler veya tekrar anahtarı değişti. Yeniden yükleyip kontrol edin.',
            yearOverlap: 'Mali yıl mevcut bir dönemle çakışıyor.',
            setupRequired: 'Önce muhasebeyi ayarlayın.',
            alreadyConfigured: 'Muhasebe zaten ayarlandı.',
            migrationRequired: 'Mevcut belge veya ödemeler var. Etkinleştirmeden önce kontrol edilmiş bir devir gerekir.',
            accountExists: 'Bu hesap numarası zaten kullanılıyor.',
            accountInvalid: 'Bir hesap eksik, etkin değil veya başka şirkete ait.',
            sourceInvalid: 'Bağlı iş ortağı veya belge bu kayda ait değil.',
            dimensionInvalid: 'Masraf merkezi veya maliyet nesnesi eksik ya da etkin değil.',
            currencyMismatch: 'Para birimleri eşleşmiyor. Açık bir dönüşüm gerekir.',
            beforeStart: 'Kayıt tarihi muhasebe başlangıcından önce.',
            cannotReverse: 'Bu kayıt bu tarihte ters kaydedilemez.',
            reverseAtSource: 'Bu kaydı kaynak belge veya ödeme üzerinden düzeltin.',
            yearClosed: 'Mali yıl kapalı.',
            draftsRemain: 'Dönemde taslaklar var. Önce bunları kontrol edin.',
            dateRange: 'Bitiş tarihi başlangıçtan önce olamaz.',
            accountInUse: 'Kullanılan hesabın numarası, türü ve amacı korunur.',
            exportLimit: 'Seçim çok fazla satır içeriyor. Dönemi veya hesapları daraltın.',
        },
        kindLabels: {
            ASSET: 'Varlık',
            LIABILITY: 'Borç',
            EQUITY: 'Özkaynak',
            REVENUE: 'Gelir',
            EXPENSE: 'Gider',
        },
        roleLabels: {
            ADVANCE_RECEIVED: 'Alınan avanslar',
            ADVANCE_PAID: 'Verilen avanslar',
            TRANSFER_CLEARING: 'Kendi hesap aktarımları',
            BAD_DEBT: 'Şüpheli alacak kayıpları',
            GENERAL: 'Genel',
            RECEIVABLE: 'Alacaklar',
            PAYABLE: 'Borçlar',
            BANK: 'Banka',
            CASH: 'Kasa',
            CLEARING: 'Mahsup',
            OUTPUT_TAX: 'Hesaplanan KDV',
            INPUT_TAX: 'İndirilecek KDV',
            DEFERRED_TAX: 'Ertelenmiş vergi',
            DISCOUNT: 'İskonto',
            FEE: 'Ücretler',
            FX: 'Kur farkları',
            OPENING: 'Açılış',
            RETAINED_EARNINGS: 'Geçmiş yıl kârı',
        },
        code: 'Kod',
        originalCurrency: 'Orijinal para birimi',
        originalAmount: 'Orijinal tutar',
        exchangeRate: 'Muhasebe para birimine kur',
        fxHint: 'Döviz için orijinal tutarı, para birimini ve açık kuru birlikte girin. Borç ve alacak muhasebe para biriminde kalır.',
        none: 'Atama yok',
        opening: 'Devir bakiyesi',
        currencyCode: 'Para birimi',
        exportJournal: 'Günlüğü CSV olarak dışa aktar',
        exportBalances: 'Mizanı CSV olarak dışa aktar',
        exportHint: 'Günlük dışa aktarımı filtreleri izler. Durum seçilmezse yalnızca kesinleşmiş kayıtlar dışa aktarılır.',
        permissionActions: {
            EXECUTE: 'Tahsil edilemeyen alacakları kaydet',
            READ: 'Muhasebeyi görüntüle',
            CREATE: 'Taslak oluştur',
            UPDATE: 'Taslak düzenle',
            APPROVE: 'Kayıtları kesinleştir',
            ARCHIVE: 'Ters kayıt oluştur',
            COMPLETE: 'Dönemleri kapat',
            RELEASE: 'Dönemleri yeniden aç',
            MANAGE_SETTINGS: 'Muhasebeyi ayarla',
            EXPORT: 'Muhasebeyi dışa aktar',
        },
    },
    fr: {
        selfAssessment: apSelfAssessmentTranslations.fr,
        unsavedTitle: 'Modifications non enregistrées',
        unsavedHint: 'Vos saisies ne sont pas enregistrées. Voulez-vous les abandonner ?',
        discard: 'Abandonner les modifications',
        vendorAllocation: {
            matchRequired: 'Effectuez d’abord le rapprochement de facture, puis rouvrez cet aperçu.',
            title: 'Imputation et comptabilisation',
            hint: 'Vérifiez l’original, répartissez les montants sur les comptes de charges ou d’actifs et contrôlez l’écriture avant validation. Les montants originaux sont conservés.',
            rate: 'Taux de change',
            zero: 'Le montant du document original est nul. Aucun paiement ni aucune écriture ne sont créés.',
            saved: 'Imputation enregistrée. Vérifiez le nouvel aperçu comptable.',
            amountHint: 'Répartissez les montants nets en {{currency}}. Utilisez un point ou une virgule décimale sans séparateur de milliers. La TVA non déductible augmente la charge ou le coût d’acquisition.',
            row: 'Répartition {{number}}',
            account: 'Compte comptable {{number}}',
            netAmount: 'Montant net {{number}}',
            taxRate: 'Taux de TVA % {{number}}',
            inputTaxDeductionPercent: 'TVA déductible % {{number}}',
            costCenterId: 'Centre de coûts {{number}}',
            costObjectId: 'Objet de coûts {{number}}',
            description: 'Libellé comptable {{number}}',
            remove: 'Supprimer la répartition {{number}}',
            rowResult: 'TVA déductible : {{deductible}} · Charge/coût d’acquisition : {{cost}}',
            add: 'Ajouter une répartition',
            save: 'Enregistrer l’imputation',
            edit: 'Modifier l’imputation',
            dimensions: 'Centre / objet de coûts',
            reason: 'Motif des écarts',
            checked: 'Original et imputation vérifiés',
            approve: 'Valider et comptabiliser après contrôle',
            refresh: 'Actualiser l’aperçu',
            findings: {
                invalidInput: 'Vérifiez les champs signalés. Saisissez les montants sans séparateur de milliers.',
                duplicatePosition: 'Chaque répartition doit avoir une position unique.',
                allocationTotalMismatch: 'Pour chaque taux de TVA, la répartition doit correspondre au montant net original.',
                allocationTaxRateMismatch: 'Ce taux de TVA est absent du document original.',
                allocationSignMismatch: 'Une répartition ne peut pas inverser le signe du montant original.',
                zeroTaxBase: 'Une taxe sans base nette correspondante nécessite un contrôle distinct.',
                sourceTaxMismatch: 'Les montants de TVA ne peuvent pas être répartis sans ambiguïté sur l’original.',
                amountOverflow: 'Le montant calculé dépasse la plage autorisée.',
                invoiceNotEditable: 'Cette facture a déjà été validée ou annulée. L’imputation enregistrée est conservée.',
                allocationMissing: 'L’imputation sélectionnée manque. Vérifiez la répartition.',
                costAccountInvalid: 'Sélectionnez un compte actif de charges, de stocks ou d’actifs dans la devise comptable. Les comptes de trésorerie, de TVA et collectifs ne sont pas autorisés ici.',
                dimensionInvalid: 'Sélectionnez un centre ou un objet de coûts actif de cette entreprise.',
                reviewRequired: 'Vérifiez et confirmez l’aperçu comptable actuel avant validation.',
                serviceDateAssumed: 'Aucune date de prestation distincte n’est enregistrée. Le contrôle utilise la date de facture ; vérifiez l’original.',
            },
        },
        vendorCorrection: {
            recorded: 'Correction enregistrée',
            author: 'Auteur',
            title: 'Saisie erronée de facture fournisseur',
            open: 'Vérifier la saisie',
            post: 'Annuler la saisie',
            evidence: 'Justificatif de correction',
            review: 'Revérifier les justificatifs',
            hint: 'Corrigez une saisie erronée avec date, motif et justificatif. Les paiements et avoirs réels du fournisseur sont enregistrés séparément. Le document et l’écriture d’origine sont conservés.',
            taxHint: 'Les corrections fiscales de saisie concernent la période fiscale initiale. Une date comptable ultérieure ne contourne pas son verrouillage.',
            sourceChanged: 'Les justificatifs ont changé. Revérifiez-les avant de valider la correction.',
            permission: 'Une facture fournisseur comptabilisée nécessite aussi le droit distinct de contrepassation.',
            unbooked: 'Cette saisie n’a pas encore été comptabilisée. Son annulation ne crée aucune écriture.',
            taxDate: 'Date fiscale de l’écriture initiale',
            correctionJournal: 'Écriture de contrepassation',
            saved: 'Saisie annulée avec justificatifs traçables.',
        },
        writeOff: {
            recover: 'Affecter un encaissement ultérieur',
            recoveryHint: 'Sélectionnez un encaissement réel existant du même client. La créance est rétablie pour ce montant et immédiatement soldée avec ce paiement. Aucun nouveau mouvement de trésorerie n’est créé. La fiscalité suit la date d’encaissement réelle.',
            recoverable: 'Montant restant passé en perte',
            noReceipts: 'Aucun encaissement correspondant avec solde disponible à partir de la date de perte. Saisissez d’abord l’encaissement réel dans Paiements.',
            recoveryReason: 'Encaissement réel ultérieur affecté à une créance précédemment passée en perte',
            recoveryAmount: 'Montant à affecter',
            recoverySave: 'Affecter le paiement et rétablir la créance',
            recoveryReview: 'Vérifier à nouveau paiement et perte',
            recoveryReviewed: 'Soldes restants et justificatifs actualisés. Vérifiez montant et date avant d’enregistrer.',
            receiptLink: 'Ouvrir le paiement existant',
            title: 'Créances irrécouvrables',
            review: 'Examiner la perte sur créance',
            hint: 'Enregistre une perte justifiée sans encaissement. Vérifiez le justificatif d’irrécouvrabilité et le traitement fiscal avant la validation.',
            amount: 'Montant brut à passer en perte',
            evidence: 'Justificatif d’irrécouvrabilité',
            account: 'Compte de charge pour créances irrécouvrables',
            selectAccount: 'Choisir un compte',
            noAccount: 'Créez dans les comptes généraux un compte de charge avec le rôle Créance irrécouvrable.',
            confirm: 'Irrécouvrabilité et traitement fiscal vérifiés',
            preview: 'Calculer l’aperçu',
            post: 'Comptabiliser la perte',
            tax: 'Correction fiscale',
            expense: 'Charge',
            reverse: 'Annuler une perte incorrecte',
            reverseHint: 'Corrige une perte enregistrée par erreur. La période fiscale d’origine doit être ouverte. Un recouvrement ultérieur réel nécessite un règlement et une correction fiscale propres.',
            recorded: 'Passé en perte',
            reversed: 'Perte annulée',
            empty: 'Cette créance ne comporte aucune perte enregistrée.',
        },
        documentDefaultsHint: 'Sans dérogation, l’ERP détermine les dates comptable et fiscale d’après le type de document, sa date et la date de prestation. Le taux représente la valeur en devise comptable d’une unité de la devise du document. Sa source reste interne.',
        views: {
            overview: 'Finances / comptabilité',
            journal: 'Journal comptable',
            accounts: 'Comptes généraux',
            reports: 'États comptables',
            periods: 'Exercices et périodes',
        },
        subtitle: 'Saisissez, vérifiez et retracez les écritures avec leurs justificatifs.',
        navigation: 'Rubriques comptables',
        help: 'Aide comptable',
        forbidden: 'Vous ne disposez pas du droit de consulter la comptabilité.',
        setup: 'Configurer la comptabilité',
        setupHint: 'Choisissez le début de la comptabilité. Les factures ou paiements existants nécessitent d’abord une reprise vérifiée. Le plan initial est extensible et ne constitue pas un plan DATEV complet.',
        startDate: 'Début comptable',
        vatMethod: 'Régime de TVA',
        ACCRUAL: 'TVA sur les débits',
        CASH: 'TVA sur les encaissements (autorisation requise)',
        saved: 'Enregistré.',
        newJournal: 'Saisir une écriture',
        journalHint: 'Tous les montants sont dans la devise comptable. Chaque ligne porte un débit ou un crédit. Les brouillons sont exclus des états. Les nouvelles écritures comptabilisées reçoivent des numéros consécutifs.',
        bookingDate: 'Date comptable',
        documentDate: 'Date du justificatif',
        taxDate: 'Date fiscale',
        serviceDate: 'Date de prestation',
        description: 'Libellé de l’écriture',
        reference: 'Référence / justification',
        line: 'Ligne {{number}}',
        account: 'Compte',
        debit: 'Débit',
        credit: 'Crédit',
        removeLine: 'Supprimer la ligne',
        addLine: 'Ajouter une ligne',
        dimensions: 'Centre de coûts et objet analytique',
        costCenterId: 'Centre de coûts',
        costObjectId: 'Objet analytique',
        saveDraft: 'Enregistrer le brouillon',
        post: 'Valider définitivement',
        reverse: 'Créer une contrepassation',
        immutableHint: 'Les écritures validées restent inchangées. Les corrections passent par une contrepassation datée et justifiée.',
        reason: 'Motif (10 caractères minimum)',
        status: 'Statut',
        DRAFT: 'Brouillon',
        POSTED: 'Validée',
        dateFrom: 'Du',
        dateTo: 'Au / date d’arrêté',
        emptyJournal: 'Aucune écriture ne correspond. Créez un brouillon ou modifiez les filtres.',
        reversalReference: 'Contrepassation de',
        lines: 'Afficher les lignes',
        chartHint: 'Les comptes appartiennent à ce dossier. Les fiches affichent leurs écritures. Les types et numéros utilisés sont protégés.',
        newAccount: 'Créer un compte général',
        journalNumber: 'Numéro d’écriture',
        number: 'Numéro de compte',
        name: 'Désignation',
        currency: 'Devise du compte (facultatif)',
        kind: 'Type de compte',
        role: 'Utilisation',
        emptyAccounts: 'Aucun compte trouvé. Créez un compte ou modifiez la recherche.',
        accountSheet: 'Ouvrir la fiche du compte',
        periodHint: 'Les périodes verrouillées bloquent les écritures. Traitez les brouillons avant clôture. La réouverture exige un droit distinct et un motif enregistré.',
        newYear: 'Créer un exercice',
        locked: 'Verrouillée',
        open: 'Ouverte',
        reopen: 'Rouvrir',
        lock: 'Verrouiller la période',
        report: 'État',
        reports: {
            trial: 'Balance générale',
            balance: 'Bilan',
            profit: 'Compte de résultat',
            bwa: 'État de gestion',
            tax: 'TVA collectée et déductible',
        },
        metrics: {
            revenue: 'Produits de la période',
            expense: 'Charges de la période',
            profit: 'Résultat de la période',
            moneyBalance: 'Solde banque/caisse comptabilisé',
        },
        bookingDateBasis: 'Date comptable : les états et grands livres utilisent le jour de comptabilisation.',
        taxDateBasis: 'Date fiscale : état, détail du compte et export utilisent la date fiscale figée. La TVA non encore exigible reste séparée.',
        reportDefinition: 'Les états ne contiennent que les lignes validées. Produits et charges ne sont pas des flux de trésorerie. Les soldes incluent l’antériorité; débit et crédit représentent les mouvements de la période. Les liens ouvrent les écritures sources.',
        bwaDefinition: 'Cet état de gestion soustrait les charges comptabilisées des produits de la période, sans les flux purement bilanciels. Il ne constitue ni une BWA DATEV standard ni une déclaration fiscale.',
        taxDefinition: 'Les comptes distinguent TVA déductible, exigible et non encore exigible. Cette vue ne transmet aucune déclaration ELSTER.',
        balanceTotals: 'Actif {{assets}} · Dettes {{liabilities}} · Capitaux propres {{equity}} · Résultat {{profit}}',
        balance: 'Solde',
        balanced: 'Débit et crédit équilibrés.',
        unbalanced: 'Débit et crédit déséquilibrés.',
        errors: {
            vendorInvoiceCancelled: 'Cette saisie de facture fournisseur a déjà été annulée.',
            vendorInvoiceHasSettlements: 'Des paiements, escomptes ou autres règlements existent. Vérifiez-les d’abord et enregistrez séparément les avoirs ou remboursements réels du fournisseur.',
            futureActualDate: 'Enregistrez uniquement les opérations effectuées au plus tard à la date courante du mandant. Les échéances futures relèvent de la planification des paiements.',
            dependentCreditCorrection: 'Cette affectation a déjà été prise en compte dans une correction validée. Examinez l’opération liée avant de corriger le paiement ; un remboursement effectif constitue un nouveau paiement.',
            creditExceeded: 'Cet avoir dépasse le montant de la facture initiale qui n’a pas déjà été crédité. Vérifiez les documents de correction validés.',
            writeOffCreditTaxReview: 'Cet avoir partiel concerne une perte sur créance avec plusieurs taux. Vérifiez d’abord la répartition fiscale.',
            writeOffRecoveryInvalid: 'Sélectionnez un encaissement réel actif du même client, daté au plus tôt du jour de la perte. Une perte initiale erronée nécessite une correction distincte.',
            writeOffSource: 'Seules les factures de vente comptabilisées avec une créance positive peuvent être passées en perte.',
            writeOffTaxReview: 'Vérifiez d’abord les cours fiscaux et la reprise de cette créance.',
            writeOffDependent: 'Des règlements ultérieurs existent après cette perte. Vérifiez-les avant de l’annuler.',
            journalOrder: 'Les numéros d’écriture ne suivent pas l’ordre attendu. Contactez votre administrateur avant de comptabiliser à nouveau.',
            accountMapping: 'Une affectation de compte manque ou est ambiguë. Vérifiez les comptes et les paramètres comptables.',
            taxRate: 'Les comptes fiscaux automatiques sont définis pour 7 % et 19 %. Les autres taux nécessitent une affectation contrôlée séparément.',
            rateEvidence: 'Indiquez un taux de change vérifiable et sa source.',
            taxReview: 'Cette compensation entre différents taux en TVA sur encaissements exige un traitement fiscal séparé.',
            allocationDate: 'L’affectation ne peut précéder le paiement ou la comptabilisation de facture. Vérifiez aussi les affectations ultérieures.',
            discountInvalid: 'L’escompte n’est pas convenu, son délai est dépassé ou le cumul dépasse les conditions convenues. La date effective du paiement fait foi.',
            transferDifference: 'Pour un virement dans la même devise, les montants doivent correspondre après déduction des frais explicitement saisis.',
            offsetInvalid: 'La compensation exige deux paiements actifs du même partenaire en sens opposés.',
            offsetCurrency: 'Dans la même devise, les montants doivent correspondre. Des devises différentes exigent deux montants explicites et une source de conversion vérifiable.',
            offsetReverseFirst: 'Annulez d’abord la compensation active dans l’historique du paiement.',
            paymentExceeded: 'Le règlement dépasse le crédit de paiement disponible.',
            allocationExceeded: 'L’affectation ou la correction d’escompte dépasse le montant ouvert ou déjà réglé.',
            adoptionRequired: 'Comptabilisez la facture ou reprenez-la dans des soldes d’ouverture contrôlés.',
            currencyFilter: 'Sélectionnez une devise avant de trier les montants.',
            taxBreakdown: 'La ventilation fiscale ne correspond pas aux montants figés de la facture.',
            financialFinalization: 'Validez définitivement la facture avant de l’envoyer.',
            managedAccount: 'Les comptes clients et fournisseurs sont mouvementés par les factures, paiements et soldes d’ouverture contrôlés.',
            validation: 'Vérifiez les champs obligatoires et montants. Vos saisies sont conservées.',
            unbalanced: 'Débit et crédit doivent être égaux; chaque ligne exige un montant.',
            periodLocked: 'La période comptable est absente, verrouillée ou rattachée à un exercice clos.',
            immutable: 'Les écritures validées sont immuables.',
            stale: 'Les données ou la clé de répétition ont changé. Rechargez et vérifiez.',
            yearOverlap: 'L’exercice chevauche une période existante.',
            setupRequired: 'Configurez d’abord la comptabilité.',
            alreadyConfigured: 'La comptabilité est déjà configurée.',
            migrationRequired: 'Des documents ou paiements existent. Une reprise vérifiée est requise avant activation.',
            accountExists: 'Ce numéro de compte existe déjà.',
            accountInvalid: 'Un compte est absent, inactif ou appartient à un autre dossier.',
            sourceInvalid: 'Le partenaire ou justificatif lié ne correspond pas à cette écriture.',
            dimensionInvalid: 'Le centre ou objet analytique est absent ou inactif.',
            currencyMismatch: 'Les devises ne correspondent pas. Une conversion explicite est nécessaire.',
            beforeStart: 'La date comptable précède le début de la comptabilité.',
            cannotReverse: 'Cette écriture ne peut pas être contrepassée à cette date.',
            reverseAtSource: 'Corrigez cette écriture depuis son document ou paiement d’origine.',
            yearClosed: 'L’exercice est clos.',
            draftsRemain: 'La période contient des brouillons. Vérifiez-les d’abord.',
            dateRange: 'La fin ne peut pas précéder le début.',
            accountInUse: 'Le numéro, le type et l’utilisation d’un compte utilisé sont protégés.',
            exportLimit: 'La sélection contient trop de lignes. Réduisez la période ou les comptes.',
        },
        kindLabels: {
            ASSET: 'Actif',
            LIABILITY: 'Passif',
            EQUITY: 'Capitaux propres',
            REVENUE: 'Produit',
            EXPENSE: 'Charge',
        },
        roleLabels: {
            ADVANCE_RECEIVED: 'Acomptes reçus',
            ADVANCE_PAID: 'Acomptes versés',
            TRANSFER_CLEARING: 'Virements internes',
            BAD_DEBT: 'Créances irrécouvrables',
            GENERAL: 'Général',
            RECEIVABLE: 'Créances',
            PAYABLE: 'Dettes',
            BANK: 'Banque',
            CASH: 'Caisse',
            CLEARING: 'Compensation',
            OUTPUT_TAX: 'TVA collectée',
            INPUT_TAX: 'TVA déductible',
            DEFERRED_TAX: 'Taxe différée',
            DISCOUNT: 'Escompte',
            FEE: 'Frais',
            FX: 'Écarts de change',
            OPENING: 'Ouverture',
            RETAINED_EARNINGS: 'Report à nouveau',
        },
        code: 'Code',
        originalCurrency: 'Devise d’origine',
        originalAmount: 'Montant d’origine',
        exchangeRate: 'Taux vers la devise comptable',
        fxHint: 'Pour une devise étrangère, indiquez ensemble montant, devise et taux explicite. Débit et crédit restent dans la devise comptable.',
        none: 'Aucune affectation',
        opening: 'Solde d’ouverture',
        currencyCode: 'Devise',
        exportJournal: 'Exporter le journal en CSV',
        exportBalances: 'Exporter la balance en CSV',
        exportHint: 'L’export du journal respecte les filtres. Sans sélection de statut, seules les écritures validées sont exportées.',
        permissionActions: {
            EXECUTE: 'Comptabiliser les créances irrécouvrables',
            READ: 'Consulter la comptabilité',
            CREATE: 'Créer des brouillons',
            UPDATE: 'Modifier les brouillons',
            APPROVE: 'Valider les écritures',
            ARCHIVE: 'Créer des contrepassations',
            COMPLETE: 'Clôturer les périodes',
            RELEASE: 'Rouvrir les périodes',
            MANAGE_SETTINGS: 'Configurer la comptabilité',
            EXPORT: 'Exporter la comptabilité',
        },
    },
    es: {
        selfAssessment: apSelfAssessmentTranslations.es,
        unsavedTitle: 'Cambios sin guardar',
        unsavedHint: 'Sus entradas no se han guardado. ¿Desea descartarlas?',
        discard: 'Descartar cambios',
        vendorAllocation: {
            matchRequired: 'Ejecute primero el cotejo de factura y vuelva a abrir esta vista previa.',
            title: 'Imputación y contabilización',
            hint: 'Revise el original, distribuya los importes entre cuentas de gasto o activo y compruebe el asiento antes de aprobarlo. Los importes originales se conservan.',
            rate: 'Tipo de cambio',
            zero: 'El documento original tiene importe cero. No se crea ningún pago ni asiento.',
            saved: 'Imputación guardada. Revise la nueva vista previa del asiento.',
            amountHint: 'Distribuya los importes netos en {{currency}}. Use punto o coma decimal sin separadores de miles. El IVA no deducible aumenta el gasto o el coste de adquisición.',
            row: 'Distribución {{number}}',
            account: 'Cuenta contable {{number}}',
            netAmount: 'Importe neto {{number}}',
            taxRate: 'Tipo de IVA % {{number}}',
            inputTaxDeductionPercent: 'Deducción de IVA % {{number}}',
            costCenterId: 'Centro de costes {{number}}',
            costObjectId: 'Objeto de costes {{number}}',
            description: 'Concepto del asiento {{number}}',
            remove: 'Eliminar distribución {{number}}',
            rowResult: 'IVA deducible: {{deductible}} · Gasto/coste de adquisición: {{cost}}',
            add: 'Añadir distribución',
            save: 'Guardar imputación',
            edit: 'Editar imputación',
            dimensions: 'Centro / objeto de costes',
            reason: 'Motivo de las diferencias',
            checked: 'Original e imputación revisados',
            approve: 'Aprobar y contabilizar tras revisión',
            refresh: 'Actualizar vista previa',
            findings: {
                invalidInput: 'Revise los campos señalados. Introduzca importes sin separadores de miles.',
                duplicatePosition: 'Cada distribución necesita una posición única.',
                allocationTotalMismatch: 'Para cada tipo de IVA, la distribución debe coincidir con el importe neto original.',
                allocationTaxRateMismatch: 'Este tipo de IVA no aparece en el original.',
                allocationSignMismatch: 'Una distribución no puede invertir el signo del importe original.',
                zeroTaxBase: 'Un impuesto sin base neta correspondiente requiere revisión específica.',
                sourceTaxMismatch: 'Los importes de IVA no pueden distribuirse inequívocamente respecto al original.',
                amountOverflow: 'El importe calculado supera el intervalo permitido.',
                invoiceNotEditable: 'Esta factura ya está aprobada o anulada. Se conserva la imputación registrada.',
                allocationMissing: 'Falta la imputación seleccionada. Revise la distribución.',
                costAccountInvalid: 'Seleccione una cuenta activa de gasto, existencias o activo en la divisa contable. Aquí no se permiten cuentas de dinero, impuestos o control.',
                dimensionInvalid: 'Seleccione un centro u objeto de costes activo de esta empresa.',
                reviewRequired: 'Revise y confirme la vista previa contable actual antes de aprobar.',
                serviceDateAssumed: 'No se ha registrado una fecha de prestación independiente. Se usa la fecha de factura para la revisión; compruebe el original.',
            },
        },
        vendorCorrection: {
            recorded: 'Rectificación registrada',
            author: 'Autor',
            title: 'Registro erróneo de factura de proveedor',
            open: 'Revisar registro',
            post: 'Anular registro',
            evidence: 'Justificante de la rectificación',
            review: 'Revisar justificantes de nuevo',
            hint: 'Corrija un registro erróneo con fecha, motivo y justificante. Los pagos y abonos reales del proveedor se registran por separado. Se conservan el documento y el asiento originales.',
            taxHint: 'Las rectificaciones fiscales del registro afectan al período fiscal original. Una fecha contable posterior no evita su bloqueo.',
            sourceChanged: 'Los justificantes han cambiado. Revíselos antes de contabilizar la rectificación.',
            permission: 'Una factura contabilizada requiere además el permiso separado para revertir asientos.',
            unbooked: 'Este registro todavía no se ha contabilizado. Su anulación no genera ningún asiento.',
            taxDate: 'Fecha fiscal del asiento original',
            correctionJournal: 'Asiento de reversión',
            saved: 'Registro anulado con justificantes trazables.',
        },
        writeOff: {
            recover: 'Asignar un cobro posterior',
            recoveryHint: 'Seleccione un cobro real existente del mismo cliente. El crédito se restablece por ese importe y se liquida inmediatamente con el pago. No se crea otro movimiento de tesorería. La fiscalidad sigue la fecha real del cobro.',
            recoverable: 'Importe restante dado de baja',
            noReceipts: 'No hay cobros coincidentes con saldo disponible desde la fecha de baja. Registre primero el cobro real en Pagos.',
            recoveryReason: 'Cobro real posterior asignado a un crédito previamente dado de baja',
            recoveryAmount: 'Importe a asignar',
            recoverySave: 'Asignar pago y restablecer crédito',
            recoveryReview: 'Revisar pago y baja de nuevo',
            recoveryReviewed: 'Saldos y justificantes actualizados. Revise importe y fecha antes de guardar.',
            receiptLink: 'Abrir pago existente',
            title: 'Créditos incobrables',
            review: 'Revisar baja por incobrable',
            hint: 'Registra una pérdida justificada sin cobro. Revise el justificante de insolvencia y el tratamiento fiscal antes de contabilizar.',
            amount: 'Importe bruto a dar de baja',
            evidence: 'Justificante de incobrabilidad',
            account: 'Cuenta de gasto por incobrables',
            selectAccount: 'Seleccionar cuenta',
            noAccount: 'Cree en las cuentas contables una cuenta de gasto con la función Incobrables.',
            confirm: 'Incobrabilidad y tratamiento fiscal revisados',
            preview: 'Calcular vista previa',
            post: 'Contabilizar baja',
            tax: 'Corrección fiscal',
            expense: 'Gasto',
            reverse: 'Anular baja incorrecta',
            reverseHint: 'Corrige una baja registrada por error. El período fiscal original debe estar abierto. Un cobro posterior real requiere su propia liquidación y corrección fiscal.',
            recorded: 'Dado de baja',
            reversed: 'Baja anulada',
            empty: 'Este crédito aún no tiene bajas registradas.',
        },
        documentDefaultsHint: 'Sin excepciones, el ERP determina las fechas contable y fiscal según el tipo, la fecha del documento y la prestación. El tipo expresa el valor de una unidad de la moneda del documento en moneda contable. La fuente permanece interna.',
        views: {
            overview: 'Finanzas / contabilidad',
            journal: 'Diario contable',
            accounts: 'Cuentas contables',
            reports: 'Informes',
            periods: 'Ejercicios y períodos',
        },
        subtitle: 'Registre, revise y consulte asientos con sus justificantes.',
        navigation: 'Secciones contables',
        help: 'Ayuda contable',
        forbidden: 'No tiene permiso para consultar la contabilidad.',
        setup: 'Configurar contabilidad',
        setupHint: 'Elija el inicio contable. Las facturas o pagos existentes requieren primero una migración revisada. El plan inicial es ampliable y no es un plan DATEV completo.',
        startDate: 'Inicio contable',
        vatMethod: 'Método de IVA',
        ACCRUAL: 'IVA por devengo',
        CASH: 'IVA por cobros (requiere autorización)',
        saved: 'Guardado.',
        newJournal: 'Nuevo asiento',
        journalHint: 'Todos los importes están en la moneda contable. Cada línea contiene un debe o un haber. Los borradores se excluyen de los informes. Los nuevos asientos contabilizados reciben números consecutivos.',
        bookingDate: 'Fecha contable',
        documentDate: 'Fecha del documento',
        taxDate: 'Fecha fiscal',
        serviceDate: 'Fecha de prestación',
        description: 'Descripción del asiento',
        reference: 'Referencia / justificación',
        line: 'Línea {{number}}',
        account: 'Cuenta',
        debit: 'Debe',
        credit: 'Haber',
        removeLine: 'Quitar línea',
        addLine: 'Añadir línea',
        dimensions: 'Centro de coste y objeto de coste',
        costCenterId: 'Centro de coste',
        costObjectId: 'Objeto de coste',
        saveDraft: 'Guardar borrador',
        post: 'Contabilizar definitivamente',
        reverse: 'Crear reversión',
        immutableHint: 'Los asientos contabilizados permanecen intactos. Las correcciones requieren una reversión fechada y justificada.',
        reason: 'Motivo (mínimo 10 caracteres)',
        status: 'Estado',
        DRAFT: 'Borrador',
        POSTED: 'Contabilizado',
        dateFrom: 'Desde',
        dateTo: 'Hasta / fecha de corte',
        emptyJournal: 'No hay asientos para estos filtros. Cree un borrador o ajuste los filtros.',
        reversalReference: 'Reversión de',
        lines: 'Mostrar líneas',
        chartHint: 'Las cuentas pertenecen a esta empresa. Las fichas muestran sus asientos. Los tipos y números utilizados quedan protegidos.',
        newAccount: 'Crear cuenta contable',
        journalNumber: 'Número de asiento',
        number: 'Número de cuenta',
        name: 'Nombre',
        currency: 'Moneda de cuenta (opcional)',
        kind: 'Tipo de cuenta',
        role: 'Uso',
        emptyAccounts: 'No se encontraron cuentas. Cree una cuenta o cambie la búsqueda.',
        accountSheet: 'Abrir ficha de cuenta',
        periodHint: 'Los períodos bloqueados impiden nuevos asientos. Resuelva los borradores antes del cierre. Reabrir requiere un permiso separado y un motivo registrado.',
        newYear: 'Crear ejercicio',
        locked: 'Bloqueado',
        open: 'Abierto',
        reopen: 'Reabrir',
        lock: 'Bloquear período',
        report: 'Informe',
        reports: {
            trial: 'Balance de sumas y saldos',
            balance: 'Balance de situación',
            profit: 'Pérdidas y ganancias',
            bwa: 'Informe de gestión',
            tax: 'IVA repercutido y soportado',
        },
        metrics: {
            revenue: 'Ingresos del período',
            expense: 'Gastos del período',
            profit: 'Resultado del período',
            moneyBalance: 'Saldo contabilizado de banco/caja',
        },
        bookingDateBasis: 'Fecha contable: informes y mayores utilizan el día de contabilización.',
        taxDateBasis: 'Fecha fiscal: informe, detalle de cuenta y exportación utilizan la fecha fiscal fijada. El IVA pendiente de devengo permanece separado.',
        reportDefinition: 'Los informes solo incluyen líneas contabilizadas. Ingresos y gastos no son flujos de efectivo. Los saldos incluyen el arrastre anterior; debe y haber muestran movimientos del período. Los enlaces abren los asientos originales.',
        bwaDefinition: 'Este informe resta los gastos contabilizados a los ingresos del período y excluye movimientos solo de balance. No es una BWA DATEV estándar ni una declaración fiscal.',
        taxDefinition: 'Las cuentas distinguen IVA soportado, exigible y pendiente de devengo. Esta vista no presenta declaraciones ELSTER.',
        balanceTotals: 'Activo {{assets}} · Pasivo {{liabilities}} · Patrimonio {{equity}} · Resultado {{profit}}',
        balance: 'Saldo',
        balanced: 'Debe y haber están equilibrados.',
        unbalanced: 'Debe y haber no coinciden.',
        errors: {
            vendorInvoiceCancelled: 'Este registro de factura de proveedor ya se ha anulado.',
            vendorInvoiceHasSettlements: 'Existen pagos, descuentos u otras liquidaciones. Revíselos primero y registre por separado los abonos o devoluciones reales del proveedor.',
            futureActualDate: 'Registre solo operaciones realizadas hasta la fecha actual del cliente ERP. Las fechas futuras corresponden a la planificación de pagos.',
            dependentCreditCorrection: 'Esta asignación ya se incluyó en una rectificación contabilizada. Revise la operación relacionada antes de corregir el pago; una devolución real es un pago nuevo.',
            creditExceeded: 'Este abono supera el importe de la factura original que todavía no se ha abonado. Revise los documentos de rectificación contabilizados.',
            writeOffCreditTaxReview: 'Este abono parcial afecta a una pérdida con varios tipos impositivos. Revise primero el reparto fiscal.',
            writeOffRecoveryInvalid: 'Seleccione un cobro real activo del mismo cliente, con fecha igual o posterior a la baja. Una baja original incorrecta requiere una corrección separada.',
            writeOffSource: 'Solo pueden darse de baja facturas de venta contabilizadas con un crédito positivo.',
            writeOffTaxReview: 'Revise primero los tipos de cambio fiscales y la incorporación de este crédito.',
            writeOffDependent: 'Existen liquidaciones posteriores a esta baja. Revíselas antes de anularla.',
            journalOrder: 'Los números de asiento no siguen el orden esperado. Contacta con la administración antes de volver a contabilizar.',
            accountMapping: 'Falta una asignación de cuenta o es ambigua. Revise las cuentas y la configuración contable.',
            taxRate: 'Las cuentas fiscales automáticas están configuradas para el 7 % y el 19 %. Otros tipos requieren una asignación revisada por separado.',
            rateEvidence: 'Indique un tipo de cambio verificable y su fuente.',
            taxReview: 'Esta compensación con distintos tipos de IVA de caja requiere un tratamiento fiscal separado.',
            allocationDate: 'La asignación no puede preceder al pago o reconocimiento de factura. Revise también las asignaciones posteriores.',
            discountInvalid: 'El descuento no está acordado, su plazo ha vencido o la deducción acumulada supera las condiciones acordadas. Se aplica la fecha real del pago.',
            transferDifference: 'En un traspaso en la misma moneda, los importes deben coincidir tras descontar las comisiones registradas expresamente.',
            offsetInvalid: 'La compensación requiere dos pagos activos del mismo interlocutor en sentidos opuestos.',
            offsetCurrency: 'En la misma moneda, los importes deben coincidir. En monedas distintas se requieren ambos importes explícitos y una fuente verificable.',
            offsetReverseFirst: 'Anule primero la compensación activa en el historial del pago.',
            paymentExceeded: 'La liquidación supera el saldo de pago disponible.',
            allocationExceeded: 'La asignación o corrección de descuento supera el importe pendiente o ya liquidado.',
            adoptionRequired: 'Contabilice la factura o incorpórela mediante saldos de apertura revisados.',
            currencyFilter: 'Seleccione una moneda antes de ordenar por importe.',
            taxBreakdown: 'El desglose fiscal no coincide con los importes fijados de la factura.',
            financialFinalization: 'Contabilice definitivamente la factura antes de enviarla.',
            managedAccount: 'Las cuentas de clientes y proveedores se registran mediante facturas, pagos y saldos de apertura revisados.',
            validation: 'Revise los campos obligatorios e importes. Se conservan sus datos.',
            unbalanced: 'Debe y haber deben coincidir; cada línea necesita un importe.',
            periodLocked: 'El período contable falta, está bloqueado o pertenece a un ejercicio cerrado.',
            immutable: 'Los asientos contabilizados son inmutables.',
            stale: 'Los datos o la clave de repetición han cambiado. Recargue y revise.',
            yearOverlap: 'El ejercicio se solapa con un período existente.',
            setupRequired: 'Configure primero la contabilidad.',
            alreadyConfigured: 'La contabilidad ya está configurada.',
            migrationRequired: 'Ya existen documentos o pagos. Se requiere una migración revisada antes de activar.',
            accountExists: 'Este número de cuenta ya existe.',
            accountInvalid: 'Una cuenta falta, está inactiva o pertenece a otra empresa.',
            sourceInvalid: 'El contacto o documento vinculado no corresponde a este asiento.',
            dimensionInvalid: 'El centro u objeto de coste falta o está inactivo.',
            currencyMismatch: 'Las monedas no coinciden. Se requiere una conversión explícita.',
            beforeStart: 'La fecha contable es anterior al inicio contable.',
            cannotReverse: 'Este asiento no puede revertirse en esta fecha.',
            reverseAtSource: 'Corrija este asiento desde el documento o pago original.',
            yearClosed: 'El ejercicio está cerrado.',
            draftsRemain: 'El período contiene borradores. Revíselos primero.',
            dateRange: 'La fecha final no puede ser anterior a la inicial.',
            accountInUse: 'El número, tipo y uso de una cuenta utilizada están protegidos.',
            exportLimit: 'La selección contiene demasiadas líneas. Reduzca el período o las cuentas.',
        },
        kindLabels: {
            ASSET: 'Activo',
            LIABILITY: 'Pasivo',
            EQUITY: 'Patrimonio',
            REVENUE: 'Ingreso',
            EXPENSE: 'Gasto',
        },
        roleLabels: {
            ADVANCE_RECEIVED: 'Anticipos recibidos',
            ADVANCE_PAID: 'Anticipos pagados',
            TRANSFER_CLEARING: 'Transferencias propias',
            BAD_DEBT: 'Créditos incobrables',
            GENERAL: 'General',
            RECEIVABLE: 'Clientes',
            PAYABLE: 'Proveedores',
            BANK: 'Banco',
            CASH: 'Caja',
            CLEARING: 'Compensación',
            OUTPUT_TAX: 'IVA repercutido',
            INPUT_TAX: 'IVA soportado',
            DEFERRED_TAX: 'Impuesto diferido',
            DISCOUNT: 'Descuento pronto pago',
            FEE: 'Comisiones',
            FX: 'Diferencias de cambio',
            OPENING: 'Apertura',
            RETAINED_EARNINGS: 'Resultados acumulados',
        },
        code: 'Código',
        originalCurrency: 'Moneda original',
        originalAmount: 'Importe original',
        exchangeRate: 'Tipo a moneda contable',
        fxHint: 'Para moneda extranjera, indique juntos importe original, moneda y tipo explícito. Debe y haber siguen en la moneda contable.',
        none: 'Sin asignación',
        opening: 'Saldo inicial',
        currencyCode: 'Moneda',
        exportJournal: 'Exportar diario a CSV',
        exportBalances: 'Exportar sumas y saldos a CSV',
        exportHint: 'La exportación del diario respeta los filtros. Sin estado seleccionado, solo se exportan asientos contabilizados.',
        permissionActions: {
            EXECUTE: 'Contabilizar créditos incobrables',
            READ: 'Consultar contabilidad',
            CREATE: 'Crear borradores',
            UPDATE: 'Editar borradores',
            APPROVE: 'Contabilizar asientos',
            ARCHIVE: 'Crear reversiones',
            COMPLETE: 'Cerrar períodos',
            RELEASE: 'Reabrir períodos',
            MANAGE_SETTINGS: 'Configurar contabilidad',
            EXPORT: 'Exportar contabilidad',
        },
    },
};
export const LEDGER_STARTER_ACCOUNTS = [
    ['1000', 'Kasse', 'ASSET', 'CASH'],
    ['1200', 'Bank', 'ASSET', 'BANK'],
    ['1360', 'Geldtransit', 'ASSET', 'CLEARING'],
    ['1361', 'Verrechnung eigener Kontoüberträge', 'ASSET', 'TRANSFER_CLEARING'],
    ['1400', 'Forderungen', 'ASSET', 'RECEIVABLE'],
    ['1600', 'Verbindlichkeiten', 'LIABILITY', 'PAYABLE'],
    ['1576', 'Vorsteuer 19 %', 'ASSET', 'INPUT_TAX'],
    ['1571', 'Vorsteuer 7 %', 'ASSET', 'INPUT_TAX'],
    ['1776', 'Umsatzsteuer 19 %', 'LIABILITY', 'OUTPUT_TAX'],
    ['1771', 'Umsatzsteuer 7 %', 'LIABILITY', 'OUTPUT_TAX'],
    ['1766', 'Umsatzsteuer nicht fällig 19 %', 'LIABILITY', 'DEFERRED_TAX'],
    ['1761', 'Umsatzsteuer nicht fällig 7 %', 'LIABILITY', 'DEFERRED_TAX'],
    ['8400', 'Erlöse 19 %', 'REVENUE', 'GENERAL'],
    ['8300', 'Erlöse 7 %', 'REVENUE', 'GENERAL'],
    ['8100', 'Steuerfreie Erlöse', 'REVENUE', 'GENERAL'],
    ['3400', 'Wareneingang 19 %', 'EXPENSE', 'GENERAL'],
    ['3300', 'Wareneingang 7 %', 'EXPENSE', 'GENERAL'],
    ['3200', 'Steuerfreier Wareneingang', 'EXPENSE', 'GENERAL'],
    ['8736', 'Gewährte Skonti', 'REVENUE', 'DISCOUNT'],
    ['3736', 'Erhaltene Skonti', 'EXPENSE', 'DISCOUNT'],
    ['4970', 'Bankgebühren', 'EXPENSE', 'FEE'],
    ['2150', 'Kursverluste', 'EXPENSE', 'FX'],
    ['2660', 'Kursgewinne', 'REVENUE', 'FX'],
    ['9000', 'Eröffnungsbilanz', 'EQUITY', 'OPENING'],
    ['0860', 'Gewinnvortrag', 'EQUITY', 'RETAINED_EARNINGS'],
];
export const LEDGER_SKR04_ACCOUNT_NUMBERS = {
    '1000': '1600',
    '1200': '1800',
    '1360': '1460',
    '1361': '1461',
    '1400': '1200',
    '1600': '3300',
    '1576': '1406',
    '1571': '1401',
    '1776': '3806',
    '1771': '3801',
    '1766': '3816',
    '1761': '3811',
    '8400': '4400',
    '8300': '4300',
    '8100': '4100',
    '3400': '5400',
    '3300': '5300',
    '3200': '5200',
    '8736': '4736',
    '3736': '5736',
    '4970': '6855',
    '2150': '6880',
    '2660': '4840',
    '9000': '9000',
    '0860': '2970',
};
//# sourceMappingURL=financial-accounting.js.map